<template>
    <div class="page">
        <box>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="当前通道" class="EL-Form-Item">
                        <el-select v-model="mainSearchMat.whCode" filterable placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode+'-'+item.whName"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearchMat.matCode" placeholder="请输入" @change="saveSearch()"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料类型" class="EL-Form-Item">
                        <el-select v-model="mainSearchMat.mtType" placeholder="请选择" filterable clearable="clearable" multiple collapse-tags>
                        <el-option v-for="(item, index) in mtTypeList" :key="index" :label="item.ddCode+' - '+item.ddName" :value="item.ddCode">
                        </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="包装箱号" class="EL-Form-Item">
                        <el-input v-model="mainSearchMat.boxBarcode" placeholder="请输入" @change="saveSearch()"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getStockPickList()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetTop">重置</el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="mainSearchMat.fcCode">
                    <el-form-item label="规值" class="EL-Form-Item">
                        <el-input v-model="mainSearchMat.matSpecs" placeholder="请输入" @change="saveSearch()"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="mainSearchMat.fcCode">
                    <el-form-item label="库位" class="EL-Form-Item">
                        <el-input v-model="mainSearchMat.lcCode" placeholder="请输入" @change="saveSearch()"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :lg="5" :xl="5" v-if="!mainSearchMat.fcCode">
                    <el-form-item label="规值" class="EL-Form-Item">
                        <el-input v-model="mainSearchMat.matSpecs" placeholder="请输入" @change="saveSearch()"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="位置类型" class="EL-Form-Item">
                        <el-select v-model="mainSearchMat.lrPointType" clearable="clearable" @change="saveSearch()">
                            <el-option label="装配" value="10" />
                            <el-option label="锻圈" value="20" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                  <el-form-item label="状态" class="EL-Form-Item">
                    <el-select v-model="mainSearchMat.receiptResult" clearable="clearable" @change="saveSearch()">
                      <el-option label="全部" value="" />
                      <el-option label="待接收" value="01" />
                      <el-option label="确认接收" value="10" />
                      <!-- <el-option label="拒绝接收" value="20" /> -->
                      <el-option label="退料" value="30" />
                    </el-select>
                  </el-form-item>
               </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="地面位置" class="EL-Form-Item">
                  <el-input v-model="mainSearchMat.lineRouter" placeholder="请输入" @change="saveSearch()"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="物料描述" class="EL-Form-Item">
                  <el-input v-model="mainSearchMat.matName" placeholder="请输入" @change="saveSearch()"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
        </box>
        <box fill>
            <plabel text="线边库存清单">
                <el-button  class="btn-t-edit" @click="printLabel(1, 'PRINT')"> 打印标签 </el-button>
                <!-- <el-button  class="btn-t-edit" @click="printLabel(1, 'PREVIEW')"> 标签预览 </el-button> -->
                <el-button v-authority="'BACK_MENU1_M5_B1'" class="btn-t-edit" @click="confirmReceipt()">确认接收</el-button>
                <!-- <el-button v-authority="'BACK_MENU1_M5_B1'" class="btn-t-edit" @click="rejectReceipt()">拒绝接收</el-button> -->
                <el-button v-authority="'BACK_MENU1_M5_B1'" class="btn-t-edit" @click="getVirtualInventory()">线上库存</el-button>
                <el-button v-authority="'BACK_MENU1_M5_B2'" class="btn-t-edit" @click="onlineUse()">上线使用</el-button>
                <el-button v-authority="'BACK_MENU1_M5_B3'" class="btn-t-edit" @click="insertStockReturnDatils()">退料</el-button>
                <!-- <el-button class="btn-t-edit" @click="insertDialogs()">添加库存</el-button> -->
                <el-button v-authority="'BACK_MENU1_M5_B4'" :loading="downloadLoadingMat" class="btn-t-edit" type="primary" @click="downLoadFileMat()">导出EXCEL</el-button>
            </plabel>
            <h-table :headerCellStyle="mainData.headerCellStyle" style="flex: 1" @pageChange="getStockPickList" :data="nextData.data" pagination :nowPage.sync="mainSearchMat.nowPage" :pageSize.sync="mainSearchMat.pageSize" :total.sync="nextData.total" @selectionChange="selectNext">
                <el-table-column  type="selection" align="center" :selectable="checkboxSelect" />
                <el-table-column label="通道编号" align="center" prop="whCode" >
                  <template slot-scope="scope">
                    <span v-if="scope.row.whCode == scope.row.realWhCode|| scope.row.realWhCode==undefined">{{scope.row.whCode}}</span>
                    <span v-if="scope.row.whCode != scope.row.realWhCode && scope.row.realWhCode!=undefined">{{scope.row.realWhCode}}({{scope.row.whCode}})</span>
                  </template>
                </el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode" />
                <el-table-column label="物料描述" align="center" prop="matName"  min-width="200"/>
                <el-table-column prop="mtType" label="物料类型" />
                <el-table-column label="数量" align="center" prop="matQuan" />
                <el-table-column label="批次号" align="center" prop="batchNo" />
                <el-table-column label="库位" align="center" prop="lcCode" />
                <el-table-column label="包装箱号" align="center" prop="boxBarcode" />
                <el-table-column label="规值" align="center" prop="matSpecs" />
                <el-table-column label="是否单品管理" align="center" prop="singletonFlag" v-if="false"/>
                <el-table-column label="入库时间" align="center" prop="matCreateTime" width="150" sortable/>
                <!-- <el-table-column label="产品状态" align="center" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
                        <span v-if="scope.row.wiStatus == 'FREEZE'">冻结</span>
                        <span v-if="scope.row.wiStatus == 'OVERTIME'">过期</span>
                        <span v-if="scope.row.wiStatus == 'DELETE'">作废</span>
                        <span v-if="scope.row.wiStatus == 'AGFREEZE'">作废</span>
                    </template>
                </el-table-column> -->
              <el-table-column label="状态" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.receiptResult == '01'">待接收</span>
                  <span v-if="scope.row.receiptResult == '10'">确认接收</span>
                  <!-- <span v-if="scope.row.receiptResult == '20'">拒绝接收</span> -->
                  <span v-if="scope.row.receiptResult == '30'">退料</span>
                </template>
              </el-table-column>
                <el-table-column label="位置类型" align="center" prop="lrPointType">
                    <template slot-scope="scope">
                        <span>{{ scope.row.lrPointType | filterLrPointType}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="地面位置" align="center" prop="routerCode"></el-table-column>
                <el-table-column label="送达时间" align="center" prop="updateTime" width="150"></el-table-column>
            </h-table>
        </box>
        <plabel text="生产退料" class="FontSize-8">
        </plabel>
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <el-select v-model="mainSearch.whCode" filterable placeholder="请选择" @change="getStockPickList(), getStockReturnMatPage()" clearable="clearable">
                            <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode+'-'+item.whName"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.matCode" placeholder="请输入" @change="returnMatSearch()"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="包装箱号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.boxBarcode" placeholder="请输入" @change="returnMatSearch()"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="状态" class="EL-Form-Item">
                        <el-select v-model="mainSearch.status" placeholder="请选择" clearable="clearable">
                            <el-option label="默认（创建、待上架、驳回）" value="CREATE,WAIT,REJECT" />
                            <el-option label="创建" value="CREATE" />
                            <el-option label="待上架" value="WAIT" />
                            <el-option label="驳回" value="REJECT" />
                            <el-option label="上架中" value="UPPERING" />
                            <el-option label="驳回已接收" value="RECEiIVE" />
                            <el-option label="完成" value="CONFIRM" />
                            <el-option label="关闭" value="CLOSE" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getStockReturnMatPage">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetMain">重置</el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form>
            <plabel>
                <el-button v-authority="'BACK_MENU1_M6_B1'" class="btn-t-edit" @click="closeTask()"> 任务关闭 </el-button>
                <el-button v-authority="'BACK_MENU1_M6_B2'" class="btn-t-edit" @click="insertRejectReceipt()"> 驳回接收 </el-button>
                <el-button v-authority="'BACK_MENU1_M6_B3'" class="btn-t-edit" @click="againResubmit()">重新提交 </el-button>
                <!-- <el-button class="btn-t-edit" type="primary" @click="prints()">单据打印</el-button> -->
                <el-button v-authority="'BACK_MENU1_M6_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <h-table :headerCellStyle="mainData.headerCellStyle" style="flex: 1" @pageChange="getStockReturnMatPage" :data="mainData.data" pagination :nowPage.sync="mainSearch.nowPage" :pageSize.sync="mainSearch.pageSize" :total.sync="mainData.total" @selectionChange="selectMain">
                <el-table-column type="selection" align="center" :selectable="checkboxSelect">
                </el-table-column>
                <el-table-column label="通道编号" align="center" prop="whCode">
                </el-table-column>
                <el-table-column label="退料单号" align="center" prop="smCode">
                </el-table-column>
                <el-table-column label="退料状态" align="center" prop="spStatus">
                    <template slot-scope="scope">
                        <span v-if="scope.row.spStatus == 'CREATE'">创建</span>
                        <span v-if="scope.row.spStatus == 'WAIT'">待上架</span>
                        <span v-if="scope.row.spStatus == 'REJECT'">驳回</span>
                        <span v-if="scope.row.spStatus == 'UPPERING'">上架中</span>
                        <span v-if="scope.row.spStatus == 'RECEiIVE'">驳回已接收</span>
                        <span v-if="scope.row.spStatus == 'CONFIRM'">完成</span>
                        <span v-if="scope.row.spStatus == 'CLOSE'">关闭</span>
                    </template>
                </el-table-column>
                 <el-table-column label="退料数量" align="center" prop="matQuan">
                </el-table-column>
                <el-table-column label="退料方式" align="center" prop="distrType">
                    <template slot-scope="scope">
                        <span v-if="scope.row.distrType == '20'">人工退料</span>
                        <span v-if="scope.row.distrType == '10'">AGV退料</span>
                    </template>
                </el-table-column>
                <el-table-column label="退料库位" align="center" prop="laCodeReturn">
                </el-table-column>
                <el-table-column label="驳回原因" align="center" prop="reasonsRejection">
                </el-table-column>
                <el-table-column label="操作人员" align="center" prop="person">
                </el-table-column>
                <el-table-column label="创建时间" align="center" prop="createTime">
                </el-table-column>
                <el-table-column label="修改时间" align="center" prop="updateTime">
                </el-table-column>
                <el-table-column label="操作" min-width="120" fixed="right">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU1_M6_B5'" class="btn-t-edit" @click="detailDialog(scope.row.smCode)">
                            明细
                        </el-button>
                    </template>
                </el-table-column>
            </h-table>
        </box>
        <!-- 线上 物料退回 -->
        <el-dialog :title="titleType" :visible.sync="onlineDialog" class="infoDialog" :close-on-click-modal="false" :show-close="false">
            <div style="overflow: hidden; padding-bottom: 10px">
                <el-form label-position="right" label-width="100px" :model="onlineInfo" ref="onlineInfo" :rules="returnInfoRules">
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="物料编号" prop="matCode" class="EL-Form-Item">
                            <el-input v-model="onlineInfo.matCode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="数量" prop="matQuan" class="EL-Form-Item">
                            <el-input v-model="onlineInfo.matQuan" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="批次号" prop="batchNo" class="EL-Form-Item">
                            <el-input v-model="onlineInfo.batchNo" placeholder="请输入" :disabled="disabled"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="包装箱号" prop="boxBarcode" class="EL-Form-Item">
                            <el-input v-model="onlineInfo.boxBarcode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="规值" prop="matSpecs" class="EL-Form-Item">
                            <el-input v-model="onlineInfo.matSpecs" placeholder="请输入" :disabled="disabled"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="入库时间" prop="matCreateTime" class="EL-Form-Item">
                            <el-date-picker v-model="onlineInfo.matCreateTime" type="date" value-format="yyyy-MM-dd" placeholder="入库时间" v-bind:disabled="disabled">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer EL-Form-Item">
                <el-button @click="operationOnline" class="btn-t-edit" size="small">保 存</el-button>
                <el-button @click="closeonlineDailog" type="info" size="small">取 消</el-button>
            </div>
        </el-dialog>
        <!-- 生产退料 -->
        <el-dialog title="生产退料" :visible.sync="dialogShow" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false" :show-close="false">
            <div style="overflow: hidden; padding-bottom: 10px">
                <el-form label-position="right" label-width="100px" :model="returnInfo" ref="returnInfo" :rules="returnInfoRules">
                    <el-col :lg="5" :xl="5" v-if="this.resd==0">
                        <el-form-item label="当前通道" prop="whCode" class="EL-Form-Item">
                            <el-select v-model="returnInfo.whCode" clearable="clearable" placeholder="请选择">
                                <el-option v-for="item in BoxBarcodeList" :key="item.whId" :value="item.whCode" :label="item.whCode">{{ item.whCode }}-{{ item.whName }}</el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="this.resd==0">
                        <el-form-item label="物料编号" prop="matCode" class="EL-Form-Item">
                            <el-input v-model="returnInfo.matCode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="this.resd==0">
                        <el-form-item label="数量" prop="boxQuan" class="EL-Form-Item">
                            <el-input v-model="returnInfo.boxQuan" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="this.resd==0 ">
                        <el-form-item label="包装箱号" prop="boxBarcode" class="EL-Form-Item">
                            <el-select v-model="returnInfo.boxBarcode" clearable="clearable" placeholder="请选择">
                                <el-option v-for="(item, index) in BoxBarcodeList" :key="index" :value="item.boxBarcode" :label="item.boxBarcode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="this.resd==1 && this.fcCode == 'SXC'">
                        <el-form-item label="配送方式" class="EL-Form-Item">
                            <el-select v-model="returnInfo.distrType" placeholder="请选择">
                                <el-option label="AGV配送" value="10" />
                                <el-option label="人工配送" value="20" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="this.resd==1">
                        <el-form-item label="库位" prop="lcCode" class="EL-Form-Item" v-if="returnInfo.distrType == '10'">
                            <el-select v-model="returnInfo.lcCode" clearable="clearable" placeholder="请选择">
                                <el-option v-for="(item, index) in sysLineRouterList" :key="index" :value="item.lrRealCode" :label="item.lrName"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="this.resd==1 || this.resd==0 ">
                        <el-form-item label="退回原因" prop="wtName"  class="EL-Form-Item">
                            <el-select v-model="returnInfo.wtName" clearable="clearable" placeholder="请选择">
                                <el-option v-for="item in warnTypeList" :key="item.wtId" :value="item.wtName" :label="item.wtName"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                  <!--<el-button  class="btn-t-edit" @click="printLabel()"> 打印标签 </el-button>-->
                    <!-- <el-col :lg="5" :xl="5" v-if="this.resd==1 ">
                        <el-form-item label="箱体高度" prop="boxHeight" class="EL-Form-Item">
                            <el-select v-model="returnInfo.boxHeight" placeholder="请选择" clearable="clearable" filterable>
                                <el-option label="一层" value="1" />
                                <el-option label="二层" value="2" />
                                <el-option label="三层" value="3" />
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                    <el-col :lg="4" :xl="4" v-if="this.resd==0">
                        <el-button class="btn-t-edit" @click="getInventoryByBoxcode()">添加</el-button>
                    </el-col>
                </el-form>
            </div>
            <div>
                <h-table :style="$popups.harvestRecordStyle(0.63)" :headerCellStyle="mainData.headerCellStyle" :data="returnList">
                    <el-table-column label="通道编号" align="center" prop="whCode">
                    </el-table-column>
                    <el-table-column label="物料编号" align="center" prop="matCode">
                    </el-table-column>
                    <el-table-column label="物料描述" align="center" prop="matName">
                    </el-table-column>
                    <el-table-column label="原有数量" align="center" prop="matQuan">
                    </el-table-column>
                    <el-table-column label="退料数量" align="center" prop="matQuan">
                    </el-table-column>
                    <el-table-column label="批次号" align="center" prop="batchNo">
                    </el-table-column>
                    <el-table-column label="包装箱号" align="center" prop="boxBarcode">
                    </el-table-column>
                    <el-table-column label="原包装箱号*" align="center" prop="oldBoxBarcode" width="200px">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.oldBoxBarcode">
                        </el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="规值" align="center" prop="matSpecs">
                      <template slot-scope="scope">
                        <el-select v-model="scope.row.matSpecs" placeholder="请选择" clearable="clearable" filterable>
                          <el-option label="+0" value="+0" />
                          <el-option label="+2" value="+2" />
                          <el-option label="-2" value="-2" />
                          <el-option label="+4" value="+4" />
                          <el-option label="-4" value="-4" />
                          <el-option label="+6" value="+6" />
                          <el-option label="-6" value="-6" />
                          <el-option label="+1" value="+1" />
                          <el-option label="-1" value="-1" />
                          <el-option label="+3" value="+3" />
                          <el-option label="-3" value="-3" />
                          <el-option label="+5" value="+5" />
                          <el-option label="-5" value="-5" />
                          <el-option label="-7" value="-7" />
                          <el-option label="+8" value="+8" />
                          <el-option label="-8" value="-8" />
                          <el-option label="+10" value="+10" />
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column label="备注" align="center" prop="remark">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.remark">
                            </el-input>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="退回原因" align="center" prop="wtName">
                    </el-table-column> -->
                </h-table>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeDailog" type="info" class="btn-t-info">关 闭</el-button>
                <el-button :loading="insertStockReturnMats" @click="insertStockReturnMat()" class="btn-t-edit" size="small">确 认</el-button>
            </div>
        </el-dialog>

        <!-- 添加通道库存 -->
        <el-dialog title="添加通道库存" :visible.sync="dialogShows" :close-on-click-modal="false" :show-close="false" class="fromDialog" :style="$popups.popups(0.8,0.9)">
            <div style="overflow: hidden; padding-bottom: 10px">
                <el-form label-position="right" label-width="100px" :model="returnInfo" ref="returnInfo" :rules="returnInfoRules">
                    <el-col :lg="5" :xl="5" v-if="insetadd==1">
                        <el-form-item label="当前通道" prop="whCode" class="EL-Form-Item">
                            <el-select v-model="returnInfo.whCode" clearable="clearable" placeholder="请选择">
                                <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode">{{ item.whCode }}-{{ item.whName }}</el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="insetadd==0">
                        <el-form-item label="物料编号" prop="matCodes" class="EL-Form-Item">
                            <el-input v-model="wipMatCode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                     <el-col :lg="5" :xl="5" v-if="insetadd==0">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="returnInfo.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions01"></el-date-picker>
                    </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="insetadd==0">
                        <el-form-item label="结束日期" class="EL-Form-Item">
                            <el-date-picker v-model="returnInfo.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions1"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="insetadd==1">
                        <el-form-item label="物料编号" prop="matCode" class="EL-Form-Item">
                            <el-input v-model="returnInfo.matCode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="insetadd==1">
                        <el-form-item label="物料描述" prop="boxQuan" class="EL-Form-Item">
                            <el-input v-model="returnInfo.matName" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="insetadd==1">
                        <el-form-item label="数量" prop="boxQuan" class="EL-Form-Item">
                            <el-input v-model="returnInfo.boxQuan" placeholder="请输入"></el-input>
                        </el-form-item>
                        <!-- </el-col>
                      <el-col :lg="4" :xl="4" v-if="insetadd==0">
                        <el-button class="btn-t-edit" @click="insetadd=1,returnLists=[]">手动添加</el-button>
                    </el-col> -->
                    </el-col>
                    <el-col :lg="4" :xl="4">
                        <el-form-item class="btn-edit-delete EL-Form-Item">
                            <el-button class="btn-t-edit" v-if="insetadd==0" @click="getBoxBarcodeList()">查询</el-button>
                            <el-button class="btn-t-edit" v-if="insetadd==1" @click="getInventory()">添加</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="insetadd==1">
                        <el-form-item label="规值" prop="boxQuan" class="EL-Form-Item">
                            <el-input v-model="returnInfo.matSpecs" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <div>
                <h-table :style="$popups.harvestRecordStyle(0.69)" :headerCellStyle="mainData.headerCellStyle" :data="wipOutInventoryList" pagination :nowPage.sync="returnSearch.nowPage" :pageSize.sync="returnSearch.pageSize" :total.sync="returnSearch.total" @selectionChange="selectWipOutInventory">
                    <el-table-column type="selection" align="center"></el-table-column>
                    <el-table-column label="通道编号" align="center" prop="whCode">
                    </el-table-column>
                    <el-table-column label="物料编号" align="center" prop="matCode">
                    </el-table-column>
                    <el-table-column label="物料描述" align="center" prop="matName">
                    </el-table-column>
                    <el-table-column label="物料数量" align="center" prop="matQuan">
                        <template slot-scope="scope">
                            <el-input size="mini" v-model="scope.row.matQuan"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="批次号" align="center" prop="batchNo">
                    </el-table-column>
                    <el-table-column label="包装箱号" align="center" prop="boxBarcode">
                    </el-table-column>
                    <el-table-column label="规值" align="center" prop="matSpecs">
                    </el-table-column>
                    <el-table-column label="时间" align="center" prop="createTime">
                    </el-table-column>
                    <!-- <el-table-column label="订单" align="center" prop="orderCode">
                    </el-table-column> -->
                </h-table>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeDailogs" type="info" class="btn-t-info">关 闭</el-button>
                <el-button :loading="insertInventoryLists" @click="insertInventoryList()" class="btn-t-edit" size="small">确 认</el-button>
            </div>
        </el-dialog>

        <!-- 生产退料明细 -->
        <el-dialog title="生产退料明细" :visible.sync="detailShow" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false" :show-close="false">
          <div style="overflow: hidden; padding-bottom: 10px;float: right;padding-top: 10px;padding-left: 30px;">
          <el-button label-position="right" @click="printLabel(2, 'PRINT')" type="info" class="btn-t-edit">打印标签</el-button>
          <!-- <el-button label-position="right" @click="printLabel(2, 'PREVIEW')" type="info" class="btn-t-edit">标签预览</el-button> -->
          </div>
          <h-table :headerCellStyle="mainData.headerCellStyle" :style="$popups.harvestRecordStyle(0.75)" @pageChange="getStockReturnMatList" :data="detailData.data" pagination :nowPage.sync="detailData.pageNum" :pageSize.sync="detailData.pageSize" :total.sync="detailData.total">
                <el-table-column label="通道编号" align="center" prop="whCode">
                </el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode">
                </el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName">
                </el-table-column>
                <el-table-column label="退料数量" align="center" prop="matQuan">
                </el-table-column>
                <el-table-column label="批次号" align="center" prop="batchNo">
                </el-table-column>
                <el-table-column label="包装箱号" align="center" prop="boxBarcode">
                </el-table-column>
                <el-table-column label="退料单号" align="center" prop="smCode">
                </el-table-column>
                <el-table-column label="退料状态" align="center" prop="spStatus">
                    <template slot-scope="scope">
                        <span v-if="scope.row.spStatus == 'CREATE'">创建</span>
                        <span v-if="scope.row.spStatus == 'WAIT'">待上架</span>
                        <span v-if="scope.row.spStatus == 'REJECT'">驳回</span>
                        <span v-if="scope.row.spStatus == 'UPPERING'">上架中</span>
                        <span v-if="scope.row.spStatus == 'RECEiIVE'">驳回已接收</span>
                        <span v-if="scope.row.spStatus == 'CONFIRM'">完成</span>
                        <span v-if="scope.row.spStatus == 'CLOSE'">关闭</span>
                    </template>
                </el-table-column>
                <el-table-column label="备注" align="center" prop="remark">
                </el-table-column>
                <el-table-column label="操作人员" align="center" prop="person">
                </el-table-column>
                <el-table-column label="创建时间" align="center" prop="createTime">
                </el-table-column>
                <el-table-column label="修改时间" align="center" prop="updateTime">
                </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeDetailDailog" type="info" class="btn-t-info">关 闭</el-button>
                <el-button v-authority="'BACK_MENU1_M6_B2'" class="btn-t-edit" @click="downLoadFileMatMx()"> 导出 </el-button>
                <!-- <el-button @click="closeDetailDailog" class="btn-t-edit">确 认</el-button> -->
            </div>
        </el-dialog>

        <!--重新提交-->
        <el-dialog title="重新提交" :visible.sync="resubmitShow" class="fromDialog" :style="$popups.popups(0.35,0.28)" :close-on-click-modal="false" :show-close="false">
            <div style="overflow: hidden; padding-bottom: 10px">
                <el-form label-position="right" label-width="80px" :model="returnInfo" ref="returnInfo" :rules="returnInfoRules">
                    <el-col :lg="12" :xl="12">
                        <el-form-item label="配送方式" class="EL-Form-Item">
                            <el-select v-model="returnInfo.distrType" placeholder="请选择">
                                <el-option label="AGV配送" value="10" />
                                <el-option label="人工配送" value="20" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="12" :xl="12">
                        <el-form-item label="库位" prop="lcCode" class="EL-Form-Item" v-if="returnInfo.distrType == '10'">
                            <el-select v-model="returnInfo.lcCode" clearable="clearable" placeholder="请选择">
                                <el-option v-for="(item, index) in sysLineRouterList" :key="index" :value="item.lrRealCode" :label="item.lrRealCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="12" :xl="12">
                        <el-form-item label="退回原因" prop="wtName" class="EL-Form-Item">
                            <el-select v-model="returnInfo.wtName" clearable="clearable" placeholder="请选择">
                                <el-option v-for="item in warnTypeList" :key="item.wtId" :value="item.wtName" :label="item.wtName"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="resubmitShow=false" type="info" class="btn-t-info">关 闭</el-button>
                <el-button :loading="insertStockReturnMats" @click="resubmit()" class="btn-t-edit" size="small">确 认</el-button>
            </div>
        </el-dialog>

        <!-- 虚拟库存 -->
        <el-dialog title="WIP+RET库存" :visible.sync="dialogShowVirtual" :close-on-click-modal="false" :show-close="false" class="fromDialog" :style="$popups.popups(0.8,0.9)">
            <div>
                <el-form label-position="right" label-width="80px" class="EL-Form">
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="物料编号" class="EL-Form-Item">
                            <el-select v-model="tableMatName" placeholder="请选择" filterable clearable="clearable">
                                <el-option v-for="(item, index) in materialList" :key="index" :label="item.mtCode" :value="item.mtCode">
                                </el-option>
                            </el-select>
                            <!-- <el-input v-model="tableMatName" placeholder="请输入" style="width:120px" clearable></el-input> -->
                        </el-form-item>
                    </el-col>
                </el-form>
              <el-form v-if="" label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                  <el-form-item label="通道号" class="EL-Form-Item">

                    <el-select v-model="tableWhCode" placeholder="请选择" filterable  clearable>
                      <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode+'-'+item.whName"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-form>
                <div style="padding:6px 0; float:left">
                    <!-- <el-button class="btn-t-edit" @click="doFilter()">搜索</el-button> -->
                    <el-button class="btn-t-edit" @click="getVirtualInventory()">搜索</el-button>
                </div>

                <div style="padding:10px 0; float:right">
                    <span v-if="returnQuartzFlag" style="font-size: 16px;padding-right: 30px;color: red;">正在同步中，请勿操作</span>
                    <el-button @click="single()" class="btn-t-edit" v-if="mainSearchMat.fcCode=='DLN'">添加单圈库存</el-button>
                  <el-button @click="updateBatchNo()" class="btn-t-edit" :disabled="returnQuartzFlag">调整批次</el-button>
                  <el-button @click="insertstock()" class="btn-t-edit" :disabled="returnQuartzFlag">退回线边库</el-button>
                  <!-- <el-button @click="returnMaterial()" class="btn-t-edit">退料</el-button> -->
                    <el-button @click="rePrintBarcode()" class="btn-t-edit">单据打印</el-button>
                </div>

                <h-table v-loading="loading" :style="$popups.harvestRecordStyle(0.68)" :headerCellStyle="mainData.headerCellStyle" :data="virtualInventoryList"  @selectionChange="selection">
                    <!--  @selectionChange="selection" -->
                    <el-table-column type="selection" align="center"></el-table-column>
                    <el-table-column label="通道编号" align="center" prop="whCode" />
                    <el-table-column label="物料编号" align="center" prop="matCode" />
                    <el-table-column label="物料描述" align="center" prop="matName" />
                  <!-- <el-table-column label="箱号" align="center" prop="boxBarcode"/>-->
                  <el-table-column label="数量" align="center" prop="matQuan" />
                  <!-- <el-table-column label="批次号" align="center" prop="batchNo" /> -->
                    <el-table-column label="批次号" align="center" prop="batchNoNew" width="150px">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.batchNoNew"></el-input>
                        </template>
					</el-table-column>
                    <el-table-column label="库位" align="center" prop="lcCode" />
                    <el-table-column label="每箱数量" align="center" prop="boxCount">
                         <template slot-scope="scope">
                             <el-input v-model="scope.row.boxCount" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                         </template>
                    </el-table-column>
                    <el-table-column label="箱数" align="center" prop="boxNumber" >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.boxNumber">
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="入库时间" align="center" prop="matCreateTime" sortable/>
                    <el-table-column label="产品状态" align="center" width="120px">
                        <template slot-scope="scope">
                            <span>{{scope.row.wiStatus | filterStatus }}</span>
                            <!-- <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
                            <span v-if="scope.row.wiStatus == 'FREEZE'">拣配中</span>
                            <span v-if="scope.row.wiStatus == 'OVERTIME'">过期</span>
                            <span v-if="scope.row.wiStatus == 'DELETE'">作废</span>
                            <span v-if="scope.row.wiStatus == 'AGFREEZE'">冻结</span> -->
                        </template>
                    </el-table-column>
                </h-table>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeInventory" type="info" class="btn-t-info">关 闭</el-button>
                <!-- <el-button :loading="insertInventoryLists" @click="insertInventoryList()" class="btn-t-edit" size="small">确 认</el-button> -->
            </div>
        </el-dialog>

         <!-- 添加单圈库存 -->
        <el-dialog title="添加单圈库存" :visible.sync="dialogShowSingleStock" :close-on-click-modal="false" :show-close="false" class="fromDialog" :style="$popups.popups(0.4,0.3)">
            <div>
                <div>
                    <el-form label-position="right" label-width="80px" class="EL-Form">
                        <el-col :lg="12" :xl="12">
                            <el-form-item label="箱号" class="EL-Form-Item">
                                <el-input v-model="tableSingle" placeholder="请输入" style="width:200px" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :xl="12">
                            <el-form-item class="EL-Form-Item">
                                <el-button class="btn-t-edit" @click="getSingleInventory()" style="margin:5px 0">添加</el-button>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </div>
                <div style="overflow-y: scroll;height: 100px;width: 100%;">
                    <el-tag
                        class="breaditem"
                        v-for="(item,index) in singleStockList"
                        :key="index"
                        @close="handleClose(item)"
                        closable
                        :disable-transitions="false"
                    >
                    {{item}}
                    </el-tag>
                </div>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="dialogShowSingleStock = false,singleStockList = [],tableSingle = ''" type="info" class="btn-t-info">关 闭</el-button>
                <el-button @click="insertSinglestock()" class="btn-t-edit" size="small">确 认</el-button>
            </div>
        </el-dialog>

        <!-- 调整批次-->
        <el-dialog title="调整批次" :visible.sync="dialogShowbatch" :close-on-click-modal="false" :show-close="false" class="fromDialog" :style="$popups.popups(0.2,0.2)">
            <div>
                <el-form label-position="right" label-width="80px" class="EL-Form">
                    <el-col :lg="5" :xl="5">
                         <el-form-item label="成本中心" class="EL-Form-Item">
                            <el-select v-model="tablecause"  style="width:200px" clearable="clearable" filterable placeholder="请选择" >
                                <!-- <el-option :value="item.reasonCode" :label="item.reasonCode +'-'+ item.reasonDescription" :key="index" v-for="(item, index) in transationReasonData"></el-option> -->
                                <el-option value="2352" label="2352-status adjustment" key="1" ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="dialogShowbatch = false,tablecause = '',updateListAll = []" type="info" class="btn-t-info">关 闭</el-button>
                <el-button @click="updateVirtualBatch()" class="btn-t-edit" size="small">确 认</el-button>
            </div>
        </el-dialog>


        <el-dialog :visible.sync="printShow" top="5px" width="1200px" :close-on-click-modal="false">
            <v-print :doPrint.sync="print">
                <div style="color: black">
                    <el-row type="flex" align="middle">
                        <el-col :lg="4" :xl="4" :offset="10">
                            <h1>虚拟库存</h1>
                        </el-col>
                        <el-col :lg="4" :xl="4" :offset="6">
                            <el-button class="btn-t-info" type="info" @click="printShow = false;">取消</el-button>
                            <el-button class="btn-t-edit" @click="print = true; printShow = true">打印</el-button>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :lg="4" :xl="4" :offset="10">
                            {{ checkPrint.hour }}
                        </el-col>
                    </el-row>
                </div>
                <div style="color: black">
                    <table width="100%" cellspacing="0">
                        <tr>
                            <th v-for="(item,index) in checkPrint.head" :key="index">{{item}}</th>
                        </tr>
                        <tr v-for="(item,index) in virtualInventoryList" :key="index">
                            <td>{{item.whCode}}</td>
                            <td>{{item.matCode}}</td>
                            <td>{{item.matName}}</td>
                            <td>{{item.matQuan}}</td>
                            <td></td>
                            <td>{{item.batchNo}}</td>
                            <td>{{item.lcCode}}</td>
                            <td>{{item.boxBarcode}}</td>
                            <td>{{item.matSpecs}}</td>
                            <td>{{item.matCreateTime}}</td>
                            <td>{{item.wiStatus | filterStatus}}</td>
                        </tr>
                    </table>
                </div>

                <div v-if="nextData.data.length" style="color: black; margin-top: 100px">
                    <el-row>
                        <el-col :lg="4" :xl="4" :offset="10">
                            <h1>通道库存</h1>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :lg="4" :xl="4" :offset="10">
                            {{ checkAisle.hour }}
                        </el-col>
                    </el-row>
                </div>
                <div v-if="nextData.data.length" style="color: black; padding-bottom: 50px">
                    <table width="100%" cellspacing="0">
                        <tr>
                            <th v-for="(item,index) in checkAisle.head" :key="index">{{item}}</th>
                        </tr>
                        <tr v-for="(item,index) in nextData.data" :key="index">
                            <td>{{item.whCode}}</td>
                            <td>{{item.matCode}}</td>
                            <td>{{item.matName}}</td>
                            <td>{{item.matQuan}}</td>
                            <td></td>
                            <td>{{item.batchNo}}</td>
                            <td>{{item.lcCode}}</td>
                            <td>{{item.boxBarcode}}</td>
                            <td>{{item.matSpecs}}</td>
                            <td>{{item.matCreateTime}}</td>
                            <td>{{item.recordDate}}</td>
                        </tr>
                    </table>
                </div>
            </v-print>
        </el-dialog>
    </div>
</template>

<script>
    import vPrint from 'syl-vue-printer'
    import plabel from '../../components/public/plabel.vue';
    import moment from 'moment'
    import { getLodop } from "@/libs/LodopFuncs.js";
    import { printParamsFormat, printBoxBarcode } from '@/libs/printBoxBarcode'
    export default {
        components: {
            plabel,
            vPrint
        },
        name: "MaterialOnlineOrReturn",
        data() {
            return {
                //虚拟库存多选集合
                checkLists: [],
                titleType: "",
                mainData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },

                nextData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },

                // 筛选条件
                mainSearch: {
                    person: localStorage.getItem("user"),
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    whCode: localStorage.getItem("whCode") || "",
                    roleCode: localStorage.getItem("roleCode") || "",
                    smCode: "",
                    matCode: "",
                    boxBarcode: "",
                    status: "CREATE,WAIT,REJECT",
                    matSpecs: "",
                    matLenValue: "",
                    date: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                },
                // 筛选条件
                mainSearchMat: {
                    person: localStorage.getItem("user"),
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    whCode: localStorage.getItem("whCode") || "",
                    smCode: "",
                    matCode: "",
                    boxBarcode: "",
                    status: "",
                    matSpecs: "",
                    matLenValue: "",
                    lrPointType: "",
                    date: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    lcCode: '',
                    receiptResult:"",
                    lineRouter:"",
                    matName:"",
                    mtType: [],
                },
                whCodeId: "",
                warehouseList: [],
                warnTypeList: [],
                boxSpecs: [],
                resd: 0,
                //多选
                checkListMain: [],
                checkListMains: [],
                checkListMainss: [],
                //工厂信息
                factory: {},

                //箱号
                BoxBarcodeList: [],
                BoxBarcodeLists: [],
                returnInfoRules: {},

                //退料料箱
				returnSearch: {
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
				},
                returnInfo: {
                    whCode: localStorage.getItem("whCode") || "",
                    boxBarcode: "",
                    bsCode: "",
                    matCode: "",
                    matCodes: "",
                    whCodeBack: "",
                    lcCode: "",
                    distrType: "",
                    wtName: "",
                    boxQuan: "",
                    matName: "",
                    matSpecs: "",
                    matLenValue: "",
                    beginTime: "",
                    boxHeight: "",
                    date: [],
                },
                returnList: [],
                returnLists: [],
                returnListss: [],
                dialogShow: false,
                dialogShows: false,
                onlineDialog: false,
                resubmitShow: false,
                //在线物料退回
                onlineInfo: {
                    whCode: localStorage.getItem("whCode") || "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    matCode: "",
                    boxBarcode: "",
                    matQuan: "",
                    batchNo: "",
                    matSpecs: "",
                    matLenValue: "",
                    position: "",
                    validityMonth: "",
                    matCreateTime: "",
                },
                disabled: false,

                //详情
                detailShow: false,
                detailData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    smCode: "",
                },
                dataList: [],
                insetadd: 0,

                person: localStorage.getItem("user"),
                fcCode: localStorage.getItem("fcCode"),

                downloadLoading: false, //下载中
                downloadLoadingMat: false, //下载中
                insertStockPrintBarcodes: false,
                insertInventoryLists: false,
                insertStockReturnMats: false,


                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注

                //记录判断
                otherRecordList: [],

                //打印
                print: false,
                printShow: false,
                checkPrint:{
                    // 表格的时间
                    hour: moment(new Date).format("yyyy-MM-DD HH:MM:SS"),
                    // 表头
                    head: ["通道","物料编号","物料描述","数量","实际数量","批次号","库位","包装箱号","规值","入库时间","产品状态"],
                    data: [],
                },
                checkAisle:{
                    // 表格的时间
                    hour: moment(new Date).format("yyyy-MM-DD HH:MM:SS"),
                    // 表头
                    head: ["通道","物料编号","物料描述","数量","实际数量","批次号","库位","包装箱号","规值","入库时间","记录时间"],
                },
                printList: [],
                timeDate: '',

                workCenter: '', //成本中心

                dialogShowVirtual: false,
                virtuallcCode: "",
                virtualInventoryList: [],
                dialogShowSingleStock: false,
                tableSingle:"",//圈号
                singleStockList:[],
                returnQuartzFlag: false,
                returnQuartzTimer: "",

                dialogShowbatch: false,
                tablecause:"2352",//原因
                //交易原因
                transationReasonData: [],
                updateListAll:[],

                virtualInventoryAllList: [],

                //agv搬运产线点位
                sysLineRouterList: [],

                //退料通道库存
                wipOutInventoryList: [],
                wipMatCode: '',
                //选中的库存
                wipOutSelectList: [],
                // 输入框延时加载
                isSetTimeout: null,
                loading: true,

                tableMatName:"",//物料编号-虚拟库存
                tableWhCode:localStorage.getItem("whCode"),//通道-虚拟库存

                //判断是否共享通道
                shareWhCodeFlag:false,
                //共享库位集合
                shareLcCodeList:[],
                //共享库位
                shareLcCodes: "",
                timer:"",

                returnInfoRules: {
                    wtName: [
                        { required: true },
                    ],
                },
                mtTypeList: [],
                materialList: []
            };
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[0]) {
                            return time.getTime() < new Date(_this.mainSearch.date[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[1]) {
                            return time.getTime() > new Date(_this.mainSearch.date[1]);
                        }
                    }
                }
            },

            pickerOptions1() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.returnInfo.date[0]) {
                            return time.getTime() < new Date(_this.returnInfo.date[0]);
                        }
                    }
                }
            },
            pickerOptions01() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.returnInfo.date[1]) {
                            return time.getTime() > new Date(_this.returnInfo.date[1]);
                        }
                    }
                }
            },
        },
        watch: {
            mainSearchMat: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getStockPickList(newVal);
                    }, 1000);
                },
                deep: true,
            },
            // nextData: {
            //     handler(newVal) {
            //         clearTimeout(this.isSetTimeout)
            //         this.isSetTimeout = setTimeout(() => {
            //             this.getStockPickList();
            //         }, 25000);
            //     },
            //     deep: true,
            // }
        },
        filters:{
            filterStatus(type){
                if (type == "NORMAL") {
                    return "正常"
                }else if (type == "FREEZE") {
                    return "拣配中"
                }else if (type == "OVERTIME") {
                    return "过期"
                }else if (type == "DELETE") {
                    return "作废"
                }else if (type == "AGFREEZE") {
                    return "冻结"
                }
            },
            filterLrPointType(type){
                if (type == "10") {
                    return "装配"
                }else if (type == "20") {
                    return "锻圈"
                }
            }
        },

        methods: {
            handleClose(item) {
                this.singleStockList.splice(this.singleStockList.indexOf(item), 1);
            },
            tabClick(row) {
                this.$set(row, "clicktext", true);
            },
            closetask(data){
                this.$set(data, "clicktext", false);
            },
            doFilter(){

                if(this.tableMatName == "" || this.tableMatName == null){

                    //this.getVirtualInventory();
                    this.virtualInventoryList = this.virtualInventoryAllList;

                }else{
                let list = [];
                this.virtualInventoryAllList.forEach((item)=>{

                    if( item.matCode.indexOf(this.tableMatName) >= 0){
                        list.push(item)
                    }

                this.virtualInventoryList = list

                })
                }
            },
            returnMaterial(){
                if (this.checkLists.length == 0) {
                    this.$message({
                        message: "请选择要退料的物料",
                        type: "warning",
                    });
                    return;
                }
                this.getLcCodeAllByWhCode();
                // this.getPointByBoxBarcode();
                // var map = [];
                // this.dataList.forEach((e) => {
                //     map.push(e.boxBarcode);
                // })
                // const res = this.checkLists.every(e => {
                //     if (map.indexOf(e.boxBarcode) > 0) {
                //         this.$message({
                //             message: "该物料已退料",
                //             type: "warning",
                //         });
                //         return false;
                //     } else {
                //         return true;
                //     }
                // })
                // if (res == false) {
                //     return false;
                // }
                this.returnInfo = {
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    date: [],
                    whCodeBack: "",
                    wtName: "",
                    lcCode: "",
                    distrType: "10"
                };
                this.resd = 1;
                this.dialogShow = true;

                this.returnList = this.checkLists;
            },
            single(){
                if (this.checkLists.length == 0) {
                    this.$message({
                        message: "请选择要保存的数据！",
                        type: "warning",
                    });
                    return false;
                }
                if(this.checkLists.length > 1){
                    this.$message({
                        message: "只能选择一条数据进行保存！",
                        type: "warning",
                    });
                    return false;
                }
                this.dialogShowSingleStock = true

            },
            getSingleInventory(){
                if(this.tableSingle == "" || this.tableSingle == null){
                    this.$message({
                        message: "圈号不能为空！",
                        type: "warning",
                    });
                    return false;
                }

                this.singleStockList.unshift(this.tableSingle);


            },
            //添加单圈库存
            insertSinglestock(){
                if (this.singleStockList.length == 0) {
                    this.$message({
                        message: "请添加需要退库的单圈库存！",
                        type: "warning",
                    });
                    return false;
                }else{
                    this.$confirm("是否确认添加库存?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        let boxBarcodes = "";
                        this.singleStockList.forEach((element) => {
                            boxBarcodes = boxBarcodes + element+ ",";
                        });
                        this.$http
                            .request({
                                url: "/api/inventory/insertSinglestock",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                    whCode: localStorage.getItem("whCode"),
                                    boxBarcodes: boxBarcodes,
                                },
                                data: this.checkLists,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.setReturnInfo();
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "SysLocation：添加库存成功";

                                    //退料条码打印
                                    var whinventoryList = resp.data;
                                    for (var index in whinventoryList) {
                                        var whData = whinventoryList[index];
                                        var produceTime = moment(whData.matCreateTime).format("YYYYMMDD");
                                        //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                                        // var qrCode = "T/" + "" + "/" + whData.boxBarcode + "/" + whData.matCode + "/" +
                                        //     whData.matQuan + "/" + whData.matSpecs + "/" + whData.newBatchNo +
                                        //     "/" + produceTime + "/" + whData.boxHeight;

                                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                                        var qrCode = whData.boxBarcode + "," + whData.orderCode + "," + whData.whCode + "," +
                                            whData.matCode + "," + whData.matQuan + "," + whData.matSpecs +
                                            "," + whData.newBatchNo + "," + produceTime + "," + ",,,";
                                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                                        var barcodeData = {
                                            boxBarcode: whData.boxBarcode,
                                            poCode: whData.orderCode,
                                            prodCode: whData.matCode,
                                            prodName: whData.matName,
                                            batchNo: whData.batchNo,
                                            count: whData.matQuan,
                                            checkPerson: localStorage.getItem("empNumber"),
                                            date: produceTime,
                                            matSpecs: whData.matSpecs,
                                            whCode: whData.whCode,
                                            qrCode: qrCode,
                                            printTime: printTime,

                                        }
                                        this.$printer.printWMSReturnBarcode(barcodeData);
                                    }
                                    this.dialogShowSingleStock = false;
                                    this.tableSingle = "";
                                    this.singleStockList = [];
                                    //刷新数据
                                    this.getVirtualInventory();

                                    this.getStockPickList();
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "SysLocation：添加库存失败";
                                }
                                this.logContent = JSON.stringify(this.checkLists);
                                this.systemLog();
                            })
                    })
                    .catch(() => {
                        this.insertInventoryLists = false;
                        this.$message({
                            type: "info",
                            message: "已取消保存",
                        });
                    });
                }
            },
            //虚拟库存添加库存
            insertstock(){
                if (this.checkLists.length == 0) {
                    this.$message({
                        message: "请选择要保存的数据！",
                        type: "warning",
                    });
                    return false;
                }
                //WIP的库存不能添加
                var  count = 0;
                this.checkLists.forEach(e =>{
                    if (e.lcCode.indexOf("WIP") > -1) {
                        count ++;
                    }
                })

                if(count > 0){
                    this.$message({
                        message: "WIP物料，请联系报工员退回RET！",
                        type: "warning",
                    });
                    return false;
                }

                const res = this.checkLists.every(e => {
					console.log("boxCount: ",e.boxCount)
					console.log("boxNumber: ",e.boxNumber)
                    if (e.batchNo != e.batchNoNew) {
                        this.$message({
                            message: "批次号有变化，请先调整批次号！",
                            type: "warning",
                        });
                        return false;
                    } else if (e.boxCount == 0 || e.boxCount == "" || e.boxCount == null) {
                        this.$message({
                            message: "请填写每箱数量！",
                            type: "warning",
                        });
                        return false;
                    } else if(e.boxNumber == "" || e.boxNumber == 0 || e.boxNumber == null){
                        this.$message({
                            message: "请填写箱数！",
                            type: "warning",
                        });
                        return false;
                    }else if((e.boxCount * e.boxNumber) > e.matQuan){
                        this.$message({
                            message: "添加库存数量不能超过该库存数量！",
                            type: "warning",
                        });
                        return false;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }
                this.checkLists.forEach(e =>{
                    if (e.boxBarcode != e.boxBarcodeNew) {
                        e.singletonFlag = true
                    }else{
                        e.singletonFlag = false
                    }

                })
                this.$confirm("确认批次号是否正确?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/inventory/insertVirtualInventory",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                    whCode: localStorage.getItem("whCode")
                                },
                                data: this.checkLists,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.setReturnInfo();
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "SysLocation：添加库存成功";

                                    //退料条码打印
                                    var whinventoryList = resp.data;
                                    for (var index in whinventoryList) {
                                        var whData = whinventoryList[index];
                                        var produceTime = moment(whData.createTime).format("YYYYMMDD");
                                        //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                                        // var qrCode = "T/" + "" + "/" + whData.boxBarcode + "/" + whData.matCode + "/" +
                                        //     whData.matQuan + "/" + whData.matSpecs + "/" + whData.newBatchNo +
                                        //     "/" + produceTime + "/" + whData.boxHeight;

                                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                                        var qrCode = whData.boxBarcode + "," + whData.orderCode + "," + whData.whCode + "," +
                                            whData.matCode + "," + whData.matQuan + "," + whData.matSpecs +
                                            "," + whData.batchNo + "," + produceTime + "," + whData.boxHeight + ",,,";
                                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                                        var barcodeData = {
                                            boxBarcode: whData.boxBarcode,
                                            poCode: whData.orderCode,
                                            prodCode: whData.matCode,
                                            prodName: whData.matName,
                                            batchNo: whData.batchNo,
                                            count: whData.matQuan,
                                            checkPerson: localStorage.getItem("empNumber"),
                                            date: produceTime,
                                            matSpecs: whData.matSpecs,
                                            whCode: whData.whCode,
                                            qrCode: qrCode,
                                            printTime: printTime,
                                        }
                                        //this.$printer.printWMSReturnBarcode(barcodeData);
                                    }
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "SysLocation：添加库存失败";
                                }
                                this.logContent = JSON.stringify(this.checkLists);
                                this.systemLog();
                                //刷新数据
                                this.getVirtualInventory();

                                this.getStockPickList();
                            })
                    })
                    .catch(() => {
                        this.insertInventoryLists = false;
                        this.$message({
                            type: "info",
                            message: "已取消保存",
                        });
                    });
            },
            //虚拟库存多选
            selection(val) {
                this.checkLists = val;
            },
            /**
             * 根据产线点的箱号查询所在位置
             */
            getPointByBoxBarcode() {
                this.$http
                    .request({
                        url: "/api/prodTask/getPointByBoxBarcode",
                        method: "GET",
                        params: {
                            boxBarcode: this.checkListMains[0].boxBarcode || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.returnInfo.lcCode = resp.data.list[0].routerCode || null;
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            //IA-根据交易类型获取数据
            getTransaction() {
                this.$http
                    .request({
                        url: "/api/transaction/getTransactionAll",
                        method: "GET",
                        params: {
                            transactionType: "IA",
                            pageNum: 1,
                            pageSize: 100,
                            reasonCode: ''
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.transationReasonData = resp.data.list || [];
                            this.tablecause = "2352";
                        }
                    })
                    .catch((error) => {

                    });
            },
            /**
             * 根据用户的工厂编号和通道编号查询所在的产线也就是库位编号
             */
            getLcCodeAllByWhCode() {
                this.$http
                    .request({
                        url: "/api/sysLineRouter/getLcCodeAllByReturnAndInput",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: localStorage.getItem("whCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.sysLineRouterList = resp.data || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            /**
             * 修改
             */
            updateDetails(row) {
                if (row.recordStatus == "系统接受") {
                    this.$message({
                        message: "该数据不能修改",
                        type: "warning",
                    });
                    return;
                }
                this.disabled = true;
                this.onlineDialog = true;
                this.onlineInfo = row;
            },

            /**
             * 关闭任务-只能关闭创建状态的
             */
            closeTask() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "没有选择内容",
                        type: "warning",
                    });
                    return;
                }
                const res = this.checkListMain.every(e => {
                    if (e.spStatus != 'CREATE' &&  e.spStatus != 'RECEiIVE') {
                        this.$message({
                            message: "只能选择创建状态的任务！",
                            type: "warning",
                        });
                        return false;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }

                let smCodes = "";
                this.checkListMain.forEach((e) => {
                    smCodes = smCodes + e.smCode + ",";
                })

                this.$confirm("是否确认关闭?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/stockReturnMat/closeTask",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    smCodes: smCodes,
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                }
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                }
                                //刷新数据
                                this.getStockReturnMatPage();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消退料",
                        });
                    });
            },
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy);
                window.lazy = window.setTimeout(() => {
                    this.getStockPickList();
                }, 1000);
            },

            // 节流搜索
            returnMatSearch() {
                if (window.lazy) window.clearTimeout(window.lazy);
                window.lazy = window.setTimeout(() => {
                    this.getStockReturnMatPage();
                }, 1000);
            },
            /**
             * 退货原因
             * */
            getWarnType() {
                this.$http
                    .request({
                        url: "/api/warnType/getWarnType",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            wtType: "30",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.warnTypeList = resp.data;
                        }
                    })
                    .catch((error) => {});
            },
            /**
             * 驳回接收
             */
            insertRejectReceipt() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "没有选择内容",
                        type: "warning",
                    });
                    return;
                }
                const res = this.checkListMain.every(e => {
                    if (e.spStatus != "REJECT") {
                        this.$message({
                            message: "该状态不能被接收",
                            type: "warning",
                        });
                        return false;
                    }else{
                        return true;
                    }
                    // else if(e.distrType != "20"){
                    //     this.$message({
                    //         message: "AGV退料不能被接收",
                    //         type: "warning",
                    //     });
                    //     return false;
                    // } else {
                    //     return true;
                    // }
                })
                if (res == false) {
                    return false;
                }
                this.$confirm("是否驳回接收?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/stockReturnMat/insertRejectReceipt",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                },
                                data: this.checkListMain
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "stockReturnMat：驳回接收成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "stockReturnMat：驳回接收失败";
                                }
                                this.logContent = JSON.stringify(this.checkListMain);
                                this.systemLog();
                                //刷新数据
                                this.getStockReturnMatPage();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消接收",
                        });
                    });
            },
            /**
             * 通道列表
             */
            getWarehouse() {
                this.$http
                    .request({
                        url: "/api/warehouse/getWarehouse",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.warehouseList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            /**
             * 判断是否是共享通道
             */
            getShareWhCode(){
                this.$http
                    .request({
                        url: "/api/sysWarehouse/getShareWhCode",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: localStorage.getItem("whCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            if(resp.data.total != 0){
                                this.shareWhCodeFlag = true;
                            }else{
                                this.shareWhCodeFlag = false;
                            }

                            //所有通道查询时需要添加 54 ,DLN  53
                            var fcCode = localStorage.getItem("fcCode");

                            var whCode = localStorage.getItem("whCode");
                            if(localStorage.getItem("roleCode") == '基面员工'||true){

                              whCode = this.tableWhCode;
                            }

                            var lcCode = "RET" + whCode + ",WIP" + whCode;
                            if(localStorage.getItem("roleCode") == '基面员工'){
                              lcCode = lcCode+",JMFO";

                            }

                            if(fcCode == "SXC"){
                                // whCode += ",54";
                                //lcCode += ",RET54,WIP54"
                            }else if(fcCode == "DLN" && !this.shareWhCodeFlag){
                                // whCode += ",53";
                                lcCode += ",RET53"
                            }else if(fcCode == "DLN" && this.shareWhCodeFlag){
                                //查询所有的共享库位
                                this.getShareLcCodeByFcCode();
                            }


                            if(fcCode != "DLN" || !this.shareWhCodeFlag){
                                this.$http
                                    .request({
                                        url: "/api/inventory/getXNWIPInventory",
                                        method: "GET",
                                        showLoading: true,
                                        params: {
                                            //whCode: whCode,
                                            matCode: this.tableMatName || null,
                                            lcCode: lcCode || "",
                                        },
                                    })
                                    .then((resp) => {
                                        this.loading = false;
                                        if (resp.status == 100) {
                                            if (resp.data.list == null) {
                                                this.$message({
                                                    message: "暂无数据",
                                                    type: "warning",
                                                });
                                            }
                                            this.virtualInventoryList = resp.data.list;
                                            for (let e of this.virtualInventoryList) {
                                                this.$set(e, "boxNumber", 0);
                                                this.$set(e, "boxCount", 0);
                                                this.$set(e, "batchNoNew", e.batchNo);
                                                this.$set(e, "boxBarcodeNew", e.boxBarcode);
                                            }

                                            this.virtualInventoryAllList = this.virtualInventoryList;
                                        }
                                    })
                                    .catch((error) => {
                                        this.loading = false;
                                    });
                            }


                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            /**
             * 根据工厂获取所有的共享库位
             */
            getShareLcCodeByFcCode(){
                this.$http
                    .request({
                        url: "/api/location/getShareLcCodeByFcCode",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.shareLcCodeList = resp.data.list || [];

                            var lcCode = "";
                            this.shareLcCodeList.forEach((item)=>{
                                lcCode += item.lcCode + ",";
                            })

                            this.$http
                                .request({
                                    url: "/api/inventory/getXNWIPInventory",
                                    method: "GET",
                                    showLoading: true,
                                    params: {
                                        matCode: this.tableMatName || null,
                                        lcCode: lcCode || "",
                                    },
                                })
                                .then((resp) => {
                                    this.loading = false;
                                    if (resp.status == 100) {
                                        if (resp.data.list == null) {
                                            this.$message({
                                                message: "暂无数据",
                                                type: "warning",
                                            });
                                        }
                                        this.virtualInventoryList = resp.data.list;
                                        for (let e of this.virtualInventoryList) {
                                            this.$set(e, "boxNumber", 0);
                                            this.$set(e, "boxCount", 0);
                                            this.$set(e, "batchNoNew", e.batchNo);
                                            this.$set(e, "boxBarcodeNew", e.boxBarcode);
                                        }

                                        this.virtualInventoryAllList = this.virtualInventoryList;
                                    }
                                })
                                .catch((error) => {
                                    this.loading = false;
                                });
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            /**
             * 获取虚拟库存
             */
            getVirtualInventory() {

                var whCode = localStorage.getItem("whCode");

                var lcCode = "";

                if((whCode == undefined || whCode == '')&&localStorage.getItem("roleCode") != '基面员工'){
                    // this.$message({
                    //     message: "请使用通道账号进行查看",
                    //     type: "warning",
                    // });
                    // return;
                }
                this.getSysQuartz();
                this.openReturnQuartz();

                this.dialogShowVirtual = true

                //所有通道查询时需要添加 54 ,DLN  53
                var fcCode = localStorage.getItem("fcCode");

                //判断是否是一厂的共享通道
                this.getShareWhCode();

            },
            /**
             * 退料 同步提醒
             */
            openReturnQuartz(){
                this.returnQuartzTimer = setInterval(() => {
                    this.getSysQuartz();
                }, 10000);
            },
            closeInventory() {
                this.dialogShowVirtual = false;
                this.virtualInventoryList = [];

                clearTimeout(this.returnQuartzTimer);
            },
            getSysQuartz() {
                this.$http.request({
                    url: "/api/inventory/getSysQuartz",
                    method: "GET",
                    params: {},
                }).then((resp) => {
                    if (resp.status==100) {
                        this.returnQuartzFlag = resp.data
                    } else {
                        this.dialogShowVirtual = false;
                        this.virtualInventoryList = [];
                        this.$message({
                            message: "退料同步提醒查询失败",
                            type: "error",
                        });
                        return false;
                    }
                }).catch((error) => {
                    this.dialogShowVirtual = false;
                    this.virtualInventoryList = [];
                    this.$message({
                        message: "退料同步提醒查询失败",
                        type: "error",
                    });
                    return false;
                });
            },


            /**
             * 生成条码
             */
            insertStockPrintBarcode() {
                if (this.checkListMainss.length == 0) {
                    this.$message({
                        message: "请选择数据",
                        type: "warning",
                    });
                    return;
                }
                this.insertStockPrintBarcodes = true;
                this.$http
                    .request({
                        url: "/api/inventory/insertStockPrintBarcode",
                        method: "POST",
                        showLoading: true,
                        params: {
                            person: localStorage.getItem("user") || "",
                            personNumber: localStorage.getItem("empNumber") || null,
                        },
                        data: this.checkListMainss,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "新增成功！",
                                type: "success",
                            });
                            this.logRemarks = "inventory：生成条码新增成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: "新增失败",
                            });
                            this.logRemarks = "inventory：生成条码新增失败";
                        }
                        this.insertStockPrintBarcodes = false;
                        // this.systemLog();
                        // this.closeonlineDailog();
                        // this.getSysLocationPage();
                    })
            },

            /**
             * 根据工厂编号查找信息
             */
            getSysFactory() {
                this.$http
                    .request({
                        url: "/api/factory/getSysFactory",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || ""
                        },
                    })
                    .then((resp) => {
                        this.factory = resp.data;
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            selectWipOutInventory(val) {
                this.wipOutSelectList = val;
            },

            /**
             * 通道库中的箱号下拉框
             */
            getBoxBarcodeList(matCode) {

                if (this.wipMatCode) {
                    matCode = this.wipMatCode;
                }

                this.$http
                    .request({
                        url: "/api/location/getBoxBarcodeList",
                        method: "GET",
                        params: {
                            pageNum: this.returnSearch.nowPage, //	页号
                            pageSize: this.returnSearch.pageSize, //	页大小
                            matCode: matCode,
                            whCode: localStorage.getItem("whCode") || "",
                            beginTime: this.returnInfo.date ?
                                this.returnInfo.date[0] : null,
                            endTime: this.returnInfo.date ?
                                this.returnInfo.date[1] : null,
                        }
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.BoxBarcodeLists = resp.data.list || [];
                            this.wipOutInventoryList = resp.data.list || [];
                            this.returnSearch.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            /**
             * 通道库出库记录,查询最近100条
             */
            getInventoryRecords() {
                this.$http
                    .request({
                        url: "/api/inventoryRecord/getBoxList",
                        method: "GET",
                        params: {
                            whCode: localStorage.getItem("whCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.BoxBarcodeList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            chackBox(item) {
                this.$http
                    .request({
                        url: "/api/mes/chackBox",
                        method: "GET",
                        params: {
                            whCode: this.returnInfo.whCode || null,
                            boxBarcode: item,
                            wirType: "OUT",
                            lcType: "WIP"
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.returnLists = resp.data || [];
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            /**
             * 线上物料退回
             */
            onlineMaterialReturn() {
                this.onlineDialog = true;
            },

            /**
             * 获取生产退料信息-退料单
             */
            getStockReturnMatPage() {
                // if (this.mainSearch.whCode == "") {
                //     this.whCodeId = localStorage.getItem("whCode") || "";
                // } else {
                //     this.whCodeId = this.mainSearch.whCode;
                // }
                this.$http
                    .request({
                        url: "/api/stockReturnMat/getStockReturnMatPage",
                        method: "GET",
                        params: {
                            pageNum: this.mainSearch.nowPage,
                            pageSize: this.mainSearch.pageSize,
                            fcCode: this.mainSearch.fcCode || null,
                            whCode: this.mainSearch.whCode || null,
                            smCode: this.mainSearch.smCode || null,
                            matCode: this.mainSearch.matCode || null,
                            boxBarcode: this.mainSearch.boxBarcode || null,
                            status: this.mainSearch.status || null,
                            beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
                            endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData.data = resp.data.list;
                            this.mainData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            /**
             * 修改
             */
            updateDetail(row) {
                this.disabled = true;
                this.onlineDialog = true;
                this.onlineInfo = row;
            },

            //线上物料退回确定
            operationOnline() {
                if (this.disabled == false) {
                    let info = {
                        whCode: localStorage.getItem("whCode") || "",
                        fcCode: localStorage.getItem("fcCode") || "",
                        matCode: this.onlineInfo.matCode,
                        boxBarcode: this.onlineInfo.boxBarcode,
                        matQuan: this.onlineInfo.matQuan,
                        batchNo: this.onlineInfo.batchNo,
                        matSpecs: this.onlineInfo.matSpecs,
                        matLenValue: this.onlineInfo.matLenValue,
                        position: this.onlineInfo.position,
                        validityMonth: this.onlineInfo.validityMonth,
                        matCreateTime: this.onlineInfo.matCreateTime,
                    }
                    this.$http
                        .request({
                            url: "/api/inventory/insertInventory",
                            method: "POST",
                            showLoading: true,
                            params: {
                                person: localStorage.getItem("user") || "",
                                personNumber: localStorage.getItem("empNumber") || null,
                            },
                            data: info,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "新增成功！",
                                    type: "success",
                                });
                                this.logRemarks = "inventory：库存新增成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: "新增失败",
                                });
                                this.logRemarks = "inventory：库存新增失败";
                            }
                            this.systemLog();
                            this.closeonlineDailog();
                            this.getSysLocationPage();
                        })
                } else {
                    this.$http
                        .request({
                            url: "/api/inventory/updateInventory",
                            method: "POST",
                            showLoading: true,
                            data: this.onlineInfo,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "修改成功！",
                                    type: "success",
                                });
                                this.logRemarks = "location：编辑成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: "修改失败",
                                });
                                this.logRemarks = "location：编辑失败";
                            }
                            this.closeonlineDailog();
                            this.getSysLocationPage();
                            this.systemLog();

                        })

                }
            },

            //删除库存数量
            deliveryDetail(row) {
                if (row.recordStatus == "系统接受") {
                    this.$message({
                        message: "该数据不能修改",
                        type: "warning",
                    });
                    return;
                }
                this.$http
                    .request({
                        url: "/api/location/deleteWhInventory",
                        method: "Delete",
                        params: {
                            wiId: row.wiId,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$message({
                                message: "操作成功！",
                                type: "success",
                            });
                        }
                        this.closeonlineDailog();
                        this.getStockPickList();
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },


            /**
             * 查询当前配送未使用的物料信息
             */
            getStockPickList() {
                var roleCode = localStorage.getItem("roleCode");
                this.$http
                    .request({
                        url: "/api/location/getSysLocationPage",
                        method: "GET",
                        params: {
                            matCode: this.mainSearchMat.matCode || null,
                            boxBarcode: this.mainSearchMat.boxBarcode || null,
                            matSpecs: this.mainSearchMat.matSpecs || null,
                            matLenValue: this.mainSearchMat.matLenValue || null,
                            whCode: this.mainSearchMat.whCode || null,
                            fcCode: this.mainSearchMat.fcCode || null,
                            lrPointType: this.mainSearchMat.lrPointType || null,
                            pageNum: this.mainSearchMat.nowPage,
                            pageSize: this.mainSearchMat.pageSize,
                            lcCode: this.mainSearchMat.lcCode,
                            receiptResult: this.mainSearchMat.receiptResult || null,
                            lineRouter:this.mainSearchMat.lineRouter,
                            roleCode:roleCode,
                            matName:this.mainSearchMat.matName,
                            mtType: this.mainSearchMat.mtType.join(',') || null
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.nextData.data = resp.data.list || [];
                            this.nextData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {});
            },

            /**
             * 获取生产退料信息-退料单明细
             */
            getStockReturnMatList() {
                this.$http
                    .request({
                        url: "/api/stockReturnMat/getStockReturnMatList",
                        method: "GET",
                        params: {
                            pageNum: this.detailData.nowPage,
                            pageSize: this.detailData.pageSize,
                            smCode: this.detailData.smCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.detailData.data = resp.data.list || [];
                            this.detailData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            /**
             * 新增退料
             */
            insertDialog() {
                this.dialogShow = true;
                this.returnInfo = {
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    whCode: localStorage.getItem("whCode") || "",
                    boxBarcode: "",
                    bsCode: "",
                    matCode: "",
                    whCodeBack: "",
                    wtName: "",
                    boxQuan: "",
                    matName: "",
                    matSpecs: "",
                    matLenValue: "",
                    date: [],
                };
            },

            /**
             * 新增通道库存
             */
            insertDialogs() {
                this.dialogShows = true;
                this.returnInfo = {
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    whCode: localStorage.getItem("whCode") || "",
                    boxBarcode: "",
                    bsCode: "",
                    matCode: "",
                    whCodeBack: "",
                    wtName: "",
                    boxQuan: "",
                    matName: "",
                    matSpecs: "",
                    matLenValue: "",
                    matCodes: "",
                    date: [],
                };
                //添加默认时间
                    this.returnInfo.date = [];
                    this.returnInfo.date.push(moment().subtract(7, 'd').format('YYYY-MM-DD HH:mm:ss'));
                    this.returnInfo.date.push(moment().add(1, 'days').format('YYYY-MM-DD HH:mm:ss'));
                this.getBoxBarcodeList("");
            },
            /**
             * 上线使用
             */
            onlineUse() {
                if (this.checkListMains.length == 0) {
                    this.$message({
                        message: "请勾选通道物料！",
                        type: "warning",
                    });
                    return;
                }
                for(var index in this.checkListMains) {
                    if (this.checkListMains[index].lcType == null || (this.checkListMains[index].lcType != 'RET'&& !this.checkListMains[index].lcCode.contains('RET'))) {
                        this.$message({
                            message: "该物料不是RET库存",
                            type: "warning",
                        });
                        return;
                    }
                    if (this.checkListMains[index].receiptResult != '10' && this.checkListMains[index].receiptResult != "" && this.checkListMains[index].receiptResult != undefined) {
                        this.$message({
                            message: "只能对确认接收或者状态为空的库存数据进行上线使用！",
                            type: "warning",
                        });
                        return;
                    }
                }
                this.$http
                    .request({
                        url: "/api/warehouse/onlineUse",
                        method: "POST",
                        showLoading: true,
                        data: this.checkListMains,
                        params: {
                            person: localStorage.getItem("user") || "",
                            personNumber: localStorage.getItem("empNumber") || null
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$message({
                                message: "操作成功",
                                type: "success",
                            });
                          var map = [];
                          this.checkListMains.forEach((e) => {
                            map.push("boxBarcode:"+e.boxBarcode+"oldBoxBarcode:"+e.oldBoxBarcode+"matQuan:"+e.matQuan);
                          })
                            this.logRemarks = "order：上线使用成功"+JSON.stringify(map);
                        } else {
                            this.$message({
                                message: resp.message,
                                type: "error",
                            });
                            this.logRemarks = "order：上线使用失败";
                        }
                        this.logContent = JSON.stringify(this.checkListMains);
                        this.systemLog();
                        //刷新数据
                        this.getStockPickList();
                        this.getStockReturnMatPage();
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            insertStockReturnDatils() {
                if (this.checkListMains.length == 0) {
                    this.$message({
                        message: "请选择要退料的物料",
                        type: "warning",
                    });
                    return;
                }
                // else if (this.checkListMains.length != 1) {
                //     this.$message({
                //         message: "只能对一箱物料进行退料操作",
                //         type: "warning",
                //     });
                //     return;
                // }
                this.getLcCodeAllByWhCode();
                //this.getPointByBoxBarcode();
                var map = [];
                this.dataList.forEach((e) => {
                    map.push(e.boxBarcode);
                })
                const res = this.checkListMains.every(e => {
                    if (map.indexOf(e.boxBarcode) > 0) {
                        this.$message({
                            message: "该物料已退料",
                            type: "warning",
                        });
                        return false;
                    } else if (e.receiptResult != undefined && e.receiptResult != "") {
                        this.$message({
                            message: "只能从上线使用退回来的数据进行退料！",
                            type: "warning",
                        });
                        return;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }
                this.returnInfo = {
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    date: [],
                    whCodeBack: "",
                    wtName: "",
                    lcCode: "",
                    distrType: "20",
                };
                var whCodelist = [];
                this.checkListMains.forEach((e) => {
                    whCodelist.push(e.whCode);
					e.matSpeces = e.matSpecs
                })
                this.resd = 1;
                this.dialogShow = true;
                this.returnList = this.checkListMains;

            },

            closeDailog() {
                this.dialogShow = false;
                this.returnList = [];
            },

            closeDailogs() {
                this.dialogShows = false;
                this.returnLists = [];
                this.insetadd = 0
            },

            closeonlineDailog() {
                this.onlineDialog = false;
                this.onlineInfo = {};
                this.disabled = false;
            },

            //添加库存-填写保存
            getInventory() {
                if (this.returnInfo.matCode == "" || this.returnInfo.matCode == null) {
                    this.$message({
                        message: "物料编号不能为空",
                        type: "warning",
                    });
                    return;
                }
                if (this.returnInfo.matName == "" || this.returnInfo.matName == null) {
                    this.$message({
                        message: "物料描述不能为空",
                        type: "warning",
                    });
                    return;
                }
                if (this.returnInfo.boxQuan == "" || this.returnInfo.boxQuan == null) {
                    this.$message({
                        message: "数量不能为空",
                        type: "warning",
                    });
                    return;
                }
                if (this.returnInfo.matSpecs == "" || this.returnInfo.matSpecs == null) {
                    this.$message({
                        message: "规值不能为空",
                        type: "warning",
                    });
                    return;
                }
                let info = {
                    matCode: this.returnInfo.matCode || null,
                    matName: this.returnInfo.matName || null,
                    matQuan: this.returnInfo.boxQuan || null,
                    batchNo: null,
                    boxBarcode: null,
                    fcCode: localStorage.getItem("fcCode") || "",
                    person: localStorage.getItem("user") || "",
                    personNumber: localStorage.getItem("empNumber") || null,
                    whCode: this.returnInfo.whCode || null,
                    matSpecs: this.returnInfo.matSpecs || null,
                    matLenValue: this.returnInfo.matLenValue || null,
                };
                this.returnLists.push(info);


                this.returnInfo = {
                    matCode: "",
                    matName: "",
                    boxQuan: "",
                    boxBarcode: "",
                    whCode: localStorage.getItem("whCode") || "",
                    matSpecs: "",
                    matLenValue: "",
                    matCodes: ""
                };
            },
            // 根据箱号获取料箱信息
            getInventoryByBoxcode() {
                if (this.submitForm("returnInfo")) {
                    let aa = this.returnList.find(
                        (element) => element.boxBarcode == this.returnInfo.boxBarcode
                    );
                    if (aa) {
                        this.$message({
                            message: "料箱已存在",
                            type: "warning",
                        });
                        return;
                    }
                    this.$http
                        .request({
                            url: "api/stockReturnMat/getInventoryByBoxcode",
                            method: "GET",
                            showLoading: true,
                            params: {
                                boxBarcode: this.returnInfo.boxBarcode,
                            },
                        })
                        .then((res) => {
                            if (res.status == 100) {
                                if (res.data.matQuan < this.returnInfo.boxQuan) {
                                    this.$message({
                                        message: "退料数量已大于料箱原本物料数",
                                        type: "warning",
                                    });
                                    return;
                                }
                                let info = {
                                    matCode: res.data.matCode,
                                    matName: res.data.matName,
                                    matQuan: this.returnInfo.boxQuan,
                                    matQuanOld: res.data.matQuan,
                                    boxBarcode: res.data.boxBarcode,
                                    batchNo: res.data.batchNo,
                                    fcCode: res.data.fcCode,
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber"),
                                    whCode: res.data.whCode,
                                    whCodeBack: this.returnInfo.whCodeBack,
                                    bsCode: this.returnInfo.bsCode,
                                    wtName: this.returnInfo.wtName,
                                };
                                this.returnList.push(info);
                            } else {
                                this.$message.error(res.message);
                            }
                            this.returnInfo = {
                                whCode: localStorage.getItem("whCode") || "",
                                boxBarcode: "",
                                bsCode: "",
                                matCode: "",
                                whCodeBack: "",
                                wtName: "",
                                boxQuan: "",
                                matName: "",
                                matSpecs: "",
                                matLenValue: "",
                                matCodes: ""
                            };
                        });
                }
            },
            //表单验证
            submitForm(formName) {
                let r = Boolean;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        r = true;
                    } else {
                        r = false;
                    }
                });
                return r;
            },
            againResubmit() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "没有选择内容",
                        type: "warning",
                    });
                    return;
                }
                const res = this.checkListMain.every(e => {
                    if (e.spStatus != "REJECT"  ) {
                        this.$message({
                            message: "请选择已驳回的数据",
                            type: "warning",
                        });
                        return false;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }
                this.getLcCodeAllByWhCode();
                this.returnInfo = {
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    whCodeBack: "",
                    wtName: "",
                    lcCode: "",
                    distrType: "",
                    date: [],
                };
                this.resubmitShow = true;
            },

            judge() {
                this.$http
                    .request({
                        url: "/api/stockReturnMat/getStockReturnMatPage",
                        method: "GET",
                        params: {
                            pageNum: this.mainData.nowPage,
                            pageSize: this.mainData.pageSize,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.dataList = resp.data.list || []
                        }
                    })

            },
            /**
             * 退料
             */
            insertStockReturnMat() {
                if (this.returnList.length == 0) {
                    this.$message({
                        message: "没有内容",
                        type: "warning",
                    });
                    return;
                }
                if (this.resd == 1) {

                    if (this.returnInfo.distrType == "") {
                        this.$message({
                            message: "请选择配送方式",
                            type: "warning",
                        });
                        return;
                    }
                    // if (this.returnInfo.whCodeBack == "") {
                    //     this.$message({
                    //         message: "请选择退回通道",
                    //         type: "warning",
                    //     });
                    //     return;
                    // }
                    if (this.returnInfo.wtName == "") {
                        this.$message({
                            message: "请选择退回原因",
                            type: "warning",
                        });
                        return;
                    }
                    if (this.returnInfo.distrType == 10) {
                        if (this.returnInfo.lcCode == "") {
                            this.$message({
                                message: "请选择库位编号",
                                type: "warning",
                            });
                            return;
                        }
                        // else if (this.returnInfo.boxHeight == "") {
                        //     this.$message({
                        //         message: "请选择箱体高度",
                        //         type: "warning",
                        //     });
                        //     return;
                        // }
                    }
                    var whCodelist = [];
                    this.returnList.forEach((e) => {
                        whCodelist.push(e.whCode);
                    })
                    // if(whCodelist.includes("01")){
                    //     this.$message({
                    //             message: "01通道无AGV配送方式！",
                    //             type: "warning",
                    //         });
                    //         return;
                    // }

                    var count = 0;
                    this.returnList.forEach((e) => {
                        if (this.returnInfo.distrType == '10') {
                            //AGV 库位未当前选中的库位
                            e.laCodeReturn = this.returnInfo.lcCode;
                        } else {
                            //人工默认当前WIP库位
                            e.laCodeReturn = e.lcCode;
                        }

                        e.laCode = e.lcCode;
                        e.distrType = this.returnInfo.distrType;
                        e.whCodeBack = this.returnInfo.whCodeBack;
                        e.wtName = this.returnInfo.wtName;
                        // e.boxHeight = this.returnInfo.boxHeight;
                        //判断退料标签是否填写
                        if(e.oldBoxBarcode == "" || e.oldBoxBarcode == undefined){
                            count ++;
                        }

                    });

                    if(count > 0){
                        this.$message({
                            message: "退料需填写原包装箱号！",
                            type: "warning",
                        });
                        return;
                    }

                }

                this.$confirm("是否确认退料?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.insertStockReturnMats = true;
                        this.$http
                            .request({
                                url: "/api/stockReturnMat/insertStockReturnMat",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                    whCode: localStorage.getItem("whCode")
                                },
                                data: this.returnList,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "stockReturnMat：确认退料成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "stockReturnMat：确认退料失败";
                                }

                                var printList = this.returnList;

                                this.insertStockReturnMats = false;
                                this.logContent = JSON.stringify(this.returnList);
                                this.systemLog();
                                //刷新数据
                                this.getStockPickList();
                                this.closeDailog();
                                this.getStockReturnMatPage();

                                for (var index in printList) {

                                    var whData = printList[index];
                                    var produceTime = moment(whData.matCreateTime).format("YYYYMMDD");

                                    //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                                    // var qrCode = "T/" + "" + "/" + whData.boxBarcode + "/" + whData.matCode + "/" +
                                    //     whData.matQuan + "/" + whData.matSpecs + "/" + whData.newBatchNo +
                                    //     "/" + produceTime + "/" + whData.boxHeight;

                                    //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                                    var qrCode = whData.boxBarcode + "," + whData.orderCode + "," + whData.whCode + "," +
                                        whData.matCode + "," + whData.matQuan + "," + whData.matSpecs +
                                        "," + whData.newBatchNo + "," + produceTime + "," + ",,,";


                                    var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                                    var barcodeData = {
                                        boxBarcode: whData.boxBarcode,
                                        poCode: whData.orderCode,
                                        prodCode: whData.matCode,
                                        prodName: whData.matName,
                                        batchNo: whData.batchNo,
                                        count: whData.matQuan,
                                        checkPerson: localStorage.getItem("empNumber"),
                                        date: produceTime,
                                        matSpecs: whData.matSpecs,
                                        whCode: whData.whCode,
                                        qrCode: qrCode,
                                        printTime: printTime,
                                        remark: whData.remark,
                                        oldBoxbarcode: whData.oldBoxBarcode,
                                        batchSbn:whData.batchSbn,
                                    }

                                    this.$printer.printWMSReturnBarcode(barcodeData);
                                }
                            })
                            .catch((error) => {
                                this.insertStockReturnMats = false;
                                this.$message({
                                    message: "操作失败",
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.insertStockReturnMats = false;
                        this.$message({
                            type: "info",
                            message: "已取消退料",
                        });
                    });
            },
            async printLabel(type,model){
                let LODOP = await this.printReturn(type,model);
                model === 'print' ? LODOP.PRINT() : LODOP.PREVIEW()
            },
           async printReturn(type,model){
            var printList = this.returnList;
            if(type == 1){
              printList = this.checkListMains;
            }else if(type == 2){
              printList = this.detailData.data;
            }
            if(!printList.length) return this.$message.error('无打印数据')

            this.insertStockReturnMats = false;
            this.logContent = JSON.stringify(this.returnList);
            let LODOP = getLodop();
            LODOP.PRINT_INIT("标签打印");

            for (var index in printList) {
              //强制分页
              LODOP.NEWPAGE();
              var whData = printList[index];
              if(type==2){
                await this.$http
                    .request({
                      url: "/api/order/getStockList",
                      method: "GET",
                      params: {
                        pageNum: this.mainData.nowPage, //	页号
                        pageSize: this.mainData.pageSize, //	页大小
                        boxBarcode:whData.boxBarcode,
                      },
                    })
                    .then((res) => {
                      if (res.status == 100
                          && Array.isArray(res.data.list) && res.data.list.length > 0) {
                          whData = res.data.list[0];
                        //   const { param, LODOP } = this.printDataFormat(whData)
                          const param = printParamsFormat(whData)
                        //设置打印样式
                        printBoxBarcode(param, LODOP)
                      } else {
                        this.$message.error("打印失败！库存未找到,可能已被流转XA系统消耗");
                      }
                    });
              }else{
                // const {param, LODOP} = this.printDataFormat(whData)
                const param = printParamsFormat(whData)
                  //设置打印样式
                printBoxBarcode(param, LODOP)
              }
            }
            return LODOP
          },
          // 生成打印数据
            printDataFormat(whData) {
                var qrCode =
                    whData.orderCode +
                    ",;" +
                    whData.matCode +
                    ",;1,;" +
                    whData.verdorCode +
                    ",;" +
                    whData.whCode +
                    ",;" +
                    whData.matQuan +
                    ",;" +
                    whData.supplier +
                    ",;" +
                    moment(whData.matProduceTime).format("YYYY-MM-DD") +
                    ",;" +
                    whData.batchNo +
                    ",;" +
                    whData.status +
                    ",;" +
                    whData.drawCode +
                    ",;" +
                    whData.traceability +
                    ",;" +
                    whData.boxBarcode +
                    ",;" +
                    whData.forgeSupplierCode +
                    ",;" +
                    whData.forgeCode +
                    ",;" +
                    whData.heatNo +
                    ",;" +
                    whData.steelCode +
                    ",;" +
                    whData.coamingType +
                    ",;" +
                    whData.storeIssueTime +
                    ",;" +
                    whData.matSpecs;
                qrCode = qrCode.replaceAll("undefined", "");
                // P247244,YY010006,1,供应商,800,200,供应商名称,2025-03-18,批次,状态,图纸版本号,供应商追溯号,BX25031800184,锻造供应商,锻造炉号,钢材炉号,钢号,围版类型,,公差
                const param = {
                    //订单号
                    orderNo: whData.orderCode,
                    //物料编号
                    wlType: whData.matCode,
                    // 供应商
                    gyCode: whData.verdorCode,
                    //通道
                    td: whData.whCode,
                    //数量
                    num: whData.matQuan,
                    // 供应商名称
                    gyName: whData.supplier,
                    //批次
                    pc: whData.batchNo,
                    // 状态
                    zt: whData.status,
                    // 图纸版本号
                    tzVersion: whData.drawCode,
                    // 供应商追溯号
                    gyTrace: whData.traceability,
                    // 箱号
                    boxBarcode: whData.boxBarcode,
                    //锻造供应商
                    dzGY: whData.forgeSupplierCode,
                    //锻造炉号
                    dzNo: whData.forgeCode,
                    //钢材炉号
                    gcLN: whData.heatNo,
                    //钢号
                    gcNo: whData.steelCode,
                    // 围板类型
                    wbType: whData.coamingType,
                    // 发货日期
                    fhDate: moment(whData.storeIssueTime).format("YYYYMMDD"),
                    // 公差
                    gc: whData.matSpecs,
                    //打印日期
                    dyDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                    //二维码
                    qrCode: qrCode,
                    // 物料名称
                    wlName: whData.matName,
                };
                let LODOP = getLodop();
                LODOP.PRINT_INIT("标签打印");
                //强制分页
                LODOP.NEWPAGE();
                return {param, LODOP}
            },
            /**
             * 重置
             */
            setStockReturnMat(){
                this.returnInfo = {
                    whCode: localStorage.getItem("whCode") || "",
                    boxBarcode: "",
                    bsCode: "",
                    matCode: "",
                    whCodeBack: "",
                    wtName: "",
                    boxQuan: "",
                    lcCode: "",
                    distrType: "",
                    matName: "",
                    matSpecs: "",
                    matLenValue: "",
                    matCodes: "",
                    boxHeight: ""
                };
            },
            /**
             *  新增库存
             */
            insertInventoryList() {
                if (this.wipOutSelectList.length == 0) {
                    this.$message({
                        message: "没有选择数据,请先选择数据",
                        type: "warning",
                    });
                    return;
                }
                this.insertInventoryLists = true;
                this.$confirm("是否确认添加库存?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/inventory/insertInventoryList",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                },
                                data: this.wipOutSelectList,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.setReturnInfo();
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "SysLocation：添加库存成功";

                                    //退料条码打印
                                    var whinventoryList = resp.data;
                                    for (var index in whinventoryList) {
                                        var whData = whinventoryList[index];
                                        var produceTime = moment(whData.matCreateTime).format("YYYYMMDD");
                                        //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                                        // var qrCode = "T/" + "" + "/" + whData.boxBarcode + "/" + whData.matCode + "/" +
                                        //     whData.matQuan + "/" + whData.matSpecs + "/" + whData.newBatchNo +
                                        //     "/" + produceTime + "/" + whData.boxHeight;

                                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                                        var qrCode = whData.boxBarcode + "," + whData.orderCode + "," + whData.whCode + "," +
                                            whData.matCode + "," + whData.matQuan + "," + whData.matSpecs +
                                            "," + whData.newBatchNo + "," + produceTime + "," + ",,,";
                                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                                        var barcodeData = {
                                            boxBarcode: whData.boxBarcode,
                                            poCode: whData.orderCode,
                                            prodCode: whData.matCode,
                                            prodName: whData.matName,
                                            batchNo: whData.batchNo,
                                            count: whData.matQuan,
                                            checkPerson: localStorage.getItem("empNumber"),
                                            date: produceTime,
                                            matSpecs: whData.matSpecs,
                                            whCode: whData.whCode,
                                            qrCode: qrCode,
                                            printTime: printTime,
                                        }
                                        this.$printer.printWMSReturnBarcode(barcodeData);
                                    }
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "SysLocation：添加库存失败";
                                }
                                this.insertInventoryLists = false;
                                this.logContent = JSON.stringify(this.returnLists);
                                this.systemLog();
                                //刷新数据

                                this.getStockPickList();
                                this.closeDailogs();
                            })
                        // .catch((error) => {
                        //     this.insertInventoryLists = false;
                        //     this.$message({
                        //         message: "操作失败",
                        //         type: "warning",
                        //     });
                        // });
                    })
                    .catch(() => {
                        this.insertInventoryLists = false;
                        this.$message({
                            type: "info",
                            message: "已取消保存",
                        });
                    });

            },
            /**
             *
             */
            setReturnInfo(){
                this.returnInfo = {
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    whCode: localStorage.getItem("whCode") || "",
                    boxBarcode: "",
                    bsCode: "",
                    matCode: "",
                    matCodes: "",
                    whCodeBack: "",
                    lcCode: "",
                    distrType: "",
                    wtName: "",
                    boxQuan: "",
                    matName: "",
                    matSpecs: "",
                    matLenValue: "",
                    beginTime: "",
                    boxHeight: "",
                    date: [],
                };
            },
            /**
             * 退料驳回
             */
            rejectStockReturnMat() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "没有选择内容",
                        type: "warning",
                    });
                    return;
                }
                this.$confirm("是否驳回退料?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        let smCodes = "";
                        this.checkListMain.forEach((element) => {
                            smCodes = smCodes + element.smCode + ",";
                        });
                        this.$http
                            .request({
                                url: "/api/stockReturnMat/rejectStockReturnMat",
                                method: "PUT",
                                showLoading: true,
                                params: {
                                    smCodes: smCodes,
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "stockReturnMat：驳回退料成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "stockReturnMat：驳回退料失败";
                                }
                                this.logContent = "smCodes：" + smCodes;
                                this.systemLog();
                                //刷新数据
                                this.getStockReturnMatPage();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消驳回",
                        });
                    });
            },

            /**
             * 重新提交
             */
            resubmit() {
                if (this.returnInfo.distrType == "") {
                    this.$message({
                        message: "请选择配送方式",
                        type: "warning",
                    });
                    return;
                }
                if (this.returnInfo.wtName == "") {
                    this.$message({
                        message: "请选择退回原因",
                        type: "warning",
                    });
                    return;
                }
                if (this.returnInfo.distrType == 10) {
                    if (this.returnInfo.lcCode == "") {
                        this.$message({
                            message: "请选择库位编号",
                            type: "warning",
                        });
                        return;
                    }

                }
                this.$confirm("是否重新提交?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        let smCodes = "";
                        this.checkListMain.forEach((element) => {
                            smCodes = smCodes + element.smCode + ",";
                        });
                        this.$http
                            .request({
                                url: "/api/stockReturnMat/resubmit",
                                method: "PUT",
                                showLoading: true,
                                params: {
                                    smCodes: smCodes || null,
                                    distrType: this.returnInfo.distrType || null,
                                    wtName: this.returnInfo.wtName || null,
                                    lcCode: this.returnInfo.lcCode || null,
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "stockReturnMat：重新提交成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "stockReturnMat：重新提交失败";
                                }
                                this.logContent = "smCodes：" + smCodes;
                                this.resubmitShow = false;
                                this.systemLog();
                                //刷新数据
                                this.getStockReturnMatPage();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消驳回",
                        });
                    });
            },
            heatNumberClick(row) {
                this.$set(row, "clicktext", true);
            },
            /**
             * 修改退料单备注
             */
            updateStockReturnMat(row) {
                this.$http
                    .request({
                        url: "/api/stockReturnMat/updateStockReturnMat",
                        method: "PUT",
                        showLoading: true,
                        data: row,
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.$set(row, "clicktext", false);
                            this.$message({
                                message: "提交成功",
                                type: "success",
                            });
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    })
            },


            //标签打印
            rePrintBarcode() {
                this.printShow = true;
                this.checkPrint.daya = this.virtualInventoryList.map(ele=>{
                    if (ele.whCode) {
                        return ele;
                    }
                })
                this.checkAisle.daya = this.nextData.data.map(ele=>{
                    if (ele.whCode) {
                        return ele;
                    }
                })
                // if (this.checkLists.length == 0) {
                //     this.$message({
                //         message: "请勾选打印单！",
                //         type: "warning",
                //     });
                //     return;
                // }
                // //无码时添加打印限制
                // if (this.lazyNext) {
                //     this.$message.error('请五秒后再打印！')
                //     return
                // } else {
                //     this.checkLists.forEach((item) => {
                //         // let od = this.orderSearch.data.find(o => o.orderCode == item.orderCode);
                //         var produceTime = moment(item.matProduceTime).format("YYYYMMDD");

                //         //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                //         // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
                //         // item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
                //         // "/" + produceTime + "/";

                //         //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                //         var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                //             item.matCode + "," + item.matQuan + "," + item.matSpecs +
                //             "," + item.batchNo + "," + produceTime + "," + item.boxHeight + ",,,";

                //         if (item.matSpecs == undefined) {
                //             item.matSpecs = "";
                //         }
                //         if (item.orderCode == undefined) {
                //             item.orderCode = "";
                //         }
                //         if (item.matSpecs == undefined) {
                //             item.matSpecs = "";
                //         }

                //         var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                //         var barcodeData = {
                //             boxBarcode: item.boxBarcode,
                //             prodCode: item.matCode,
                //             prodName: item.matName,
                //             batchNo: item.batchNo,
                //             count: item.matQuan,
                //             checkPerson: localStorage.getItem("empNumber"),
                //             date: produceTime,
                //             poCode: item.orderCode,
                //             matSpecs: item.matSpecs,
                //             whCode: item.whCode,
                //             qrCode: qrCode,
                //             supply: "",
                //             printTime: printTime
                //         }

                //         this.$printer.printWMSBarcode(barcodeData);
                //     })

                //     this.lazyNext = setTimeout(() => {
                //         this.lazyNext = null
                //     }, 5000)
                // }
            },



            /**
             * 明细
             */
            detailDialog(smCode) {
                this.detailShow = true;
                this.detailData.smCode = smCode;
                this.getStockReturnMatList();
            },
            closeDetailDailog() {
                this.detailShow = false;
            },

            /**
             * 多选
             */
            selectMain(val) {
                this.checkListMain = val;
            },

            selectNext(val) {
                this.checkListMains = val;
            },

            selectNexts(val) {
                this.checkListMainss = val;
            },
            //禁选
            checkboxSelect(row, rowIndex) {
                // if (row.spStatus == 'CREATE') {
                //     return true // 不禁用
                // } else {
                //     return false // 禁用
                // }
                return true;
            },
            /**
             * 重置
             */
            resetMain() {
                this.mainSearch = {
                    nowPage: 1,
                    pageSize: 50,
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    whCode: localStorage.getItem("whCode") || "",
                    person: localStorage.getItem("user") || "",
                    smCode: "",
                    matCode: "",
                    boxBarcode: "",
                    status: "CREATE,WAIT,REJECT",
                    matSpecs: "",
                    matLenValue: "",
                    date: [],
                };
                this.getStockReturnMatPage();
                this.getStockPickList();
            },

            /**
             * 重置
             */
            resetTop() {
                this.mainSearchMat = {
                    nowPage: 1,
                    pageSize: 50,
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    whCode: localStorage.getItem("whCode") || "",
                    smCode: "",
                    matCode: "",
                    boxBarcode: "",
                    status: "",
                    matSpecs: "",
                    matLenValue: "",
                    lrPointType: "",
                    date: [],
                    mtType: []
                };
                // this.getStockPickList();
            },

            //表格导出
            downLoadFileMat() {
                this.downloadLoadingMat = true;
                if(this.checkListMains.length != 0){
                  this.downLoadMat(this.checkListMains);
                  return;
                }
                var roleCode = localStorage.getItem("roleCode");
                var paramsObj = {
                    matCode: this.mainSearchMat.matCode || null,
                    boxBarcode: this.mainSearchMat.boxBarcode || null,
                    matSpecs: this.mainSearchMat.matSpecs || null,
                    matLenValue: this.mainSearchMat.matLenValue || null,
                    whCode: this.mainSearchMat.whCode || null,
                    fcCode: this.mainSearchMat.fcCode || null,
                    receiptResult: this.mainSearchMat.receiptResult || null,
                    lineRouter:this.mainSearchMat.lineRouter,
                    roleCode:roleCode,
                    matName:this.mainSearchMat.matName,
                    pageNum: 1,
                    pageSize: 999999,
                    mtType: this.mainSearchMat.mtType.join(',') || null
                }
                this.$http.request({
                    url: '/api/location/getSysLocationPage',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoadMat(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            //表格导出
            downLoadFileMatMx(){
              this.$http
                  .request({
                    url: "/api/stockReturnMat/getStockReturnMatList",
                    method: "GET",
                    params: {
                      pageNum: 1,
                      pageSize: 99999,
                      smCode: this.detailData.smCode,
                    },
                  })
                  .then((resp) => {
                    if (resp.status == 100) {
                      this.downLoadMatTl(resp.data.list || []);
                    }
                  })
                  .catch((error) => {
                    this.$message({
                      message: "操作失败",
                      type: "warning",
                    });
                  });
            },
          downLoadMatTl(list) {
            import('@/libs/Export2Excel').then(excel => {
              list.forEach(function(c) {
                if (c.wiStatus == 'NORMAL') {
                  c['wiStatus'] = '正常'
                } else if (c.wiStatus == 'FREEZE') {
                  c['wiStatus'] = '冻结'
                } else if (c.wiStatus == 'OVERTIME') {
                  c['wiStatus'] = '过期'
                } else if (c.wiStatus == 'DELETE') {
                  c['wiStatus'] = '作废'
                } else if (c.wiStatus == 'AGFREEZE') {
                  c['wiStatus'] = '人工冻结'
                } else {
                  c['wiStatus'] = ''
                }
                if (c.spStatus == 'CREATE') {
                  c['spStatus'] = '创建'
                } else if (c.spStatus == 'WAIT') {
                  c['spStatus'] = '待上架'
                } else if (c.spStatus == 'REJECT') {
                  c['spStatus'] = '驳回'
                } else if (c.spStatus == 'UPPERING') {
                  c['spStatus'] = '上架中'
                }else if (c.spStatus == 'RECEiIVE') {
                  c['spStatus'] = '驳回已接收'
                }else if (c.spStatus == 'CLOSE') {
                  c['spStatus'] = '关闭'
                }else if (c.spStatus == 'CONFIRM') {
                  c['spStatus'] = '完成'
                }
                if(c.realWhCode != undefined && c.whCode != c.realWhCode){
                  c.whCode = c.realWhCode+"("+c.whCode+")";
                }

                if (c.lrPointType == '10') {
                  c['lrPointType'] = '装配'
                } else if (c.lrPointType == '20') {
                  c['lrPointType'] = '锻圈'
                }
              })

              const tHeader = ['通道编号', '物料编号', '物料描述', '物料数量', '批次号', '包装箱号', '退料单号', '退料状态', '备注', '操作人员',
                '创建时间','修改时间'
              ]
              const filterVal = ['whCode', 'matCode', 'matName', 'matQuan', 'batchNo', 'boxBarcode', 'smCode', 'spStatus',
                'remark', 'person','createTime', 'updateTime'
              ]
              const data = this.formatJson(filterVal, list)
              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename: '通道退料明细'
              })
              this.logContent = "导出"
              this.logRemarks = "wh_inventory：导出通道物料记录"
              this.systemLog();
              this.downloadLoadingMat = false
            })
          },
            downLoadMat(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.wiStatus == 'NORMAL') {
                            c['wiStatus'] = '正常'
                        } else if (c.wiStatus == 'FREEZE') {
                            c['wiStatus'] = '冻结'
                        } else if (c.wiStatus == 'OVERTIME') {
                            c['wiStatus'] = '过期'
                        } else if (c.wiStatus == 'DELETE') {
                            c['wiStatus'] = '作废'
                        } else if (c.wiStatus == 'AGFREEZE') {
                            c['wiStatus'] = '人工冻结'
                        } else {
                            c['wiStatus'] = ''
                        }
                        if(c.realWhCode != undefined && c.whCode != c.realWhCode){
                          c.whCode = c.realWhCode+"("+c.whCode+")";
                        }

                         if (c.lrPointType == '10') {
                            c['lrPointType'] = '装配'
                        } else if (c.lrPointType == '20') {
                            c['lrPointType'] = '锻圈'
                        }
                        if (c.receiptResult == '01') {
                          c['receiptResult'] = '待接收'
                        } else if (c.receiptResult == '10') {
                          c['receiptResult'] = '确认接收'
                        }else if (c.receiptResult == '20') {
                          c['receiptResult'] = '拒绝接收'
                        }else if (c.receiptResult == '30') {
                          c['receiptResult'] = '退货'
                        }
                    })

                    const tHeader = ['通道编号', '物料编号', '物料描述', '物料类型', '数量', '批次号', '货位号', '包装箱号', '规值', '入库时间','状态', '位置类型', '地面位置',
                        '送达时间'
                    ]
                    const filterVal = ['whCode', 'matCode', 'matName', 'mtType', 'matQuan', 'batchNo', 'lcCode', 'boxBarcode', 'matSpecs', 'matCreateTime',
                        'receiptResult','lrPointType', 'routerCode', 'updateTime'
                    ]
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '通道物料'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "wh_inventory：导出通道物料记录"
                    this.systemLog();
                    this.downloadLoadingMat = false
                })
            },
            downLoadFile() {
                if(this.checkListMain.length != 0){
                  this.downLoad(this.checkListMain);
                  return;
                }
                this.downloadLoading = true;
                var paramsObj = {
                    fcCode: this.mainSearch.fcCode || null,
                    whCode: this.mainSearch.whCode || null,
                    smCode: this.mainSearch.smCode || null,
                    matCode: this.mainSearch.matCode || null,
                    boxBarcode: this.mainSearch.boxBarcode || null,
                    status: this.mainSearch.status || null,
                    beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
                    endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
                    pageNum: 1,
                    pageSize: 999999,
                }
                this.$http.request({
                    url: '/api/stockReturnMat/getStockReturnMatPage',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.spStatus == 'CREATE') {
                            c['spStatus'] = '创建'
                        } else if (c.spStatus == 'WAIT') {
                            c['spStatus'] = '待上架'
                        } else if (c.spStatus == 'REJECT') {
                            c['spStatus'] = '驳回'
                        } else if (c.spStatus == 'UPPERING') {
                            c['spStatus'] = '上架中'
                        }else if (c.spStatus == 'RECEiIVE') {
                            c['spStatus'] = '驳回已接收'
                        }else if (c.spStatus == 'CLOSE') {
                            c['spStatus'] = '关闭'
                        }else if (c.spStatus == 'CONFIRM') {
                            c['spStatus'] = '完成'
                        }

                        if (c.distrType == '20') {
                            c['distrType'] = '人工退料'
                        } else if (c.distrType == '10') {
                            c['distrType'] = 'AGV退料'
                        }
                    })
                    const tHeader = ['通道编号', '退料单号', '退料状态', '退料数量', '退料方式', '退料库位', '驳回原因', '操作人员', '创建时间', '修改时间']
                    const filterVal = ['whCode', 'smCode', 'spStatus', 'matQuan', 'distrType','laCodeReturn', 'reasonsRejection', 'person', 'createTime', 'updateTime']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '生产退料'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "stock_return_mat：导出生产退料记录"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            //打印

            /**
             * 全选
             */
            selectAllMain(val) {
                this.checkListMain = val;
            },

            /**
             * 禁选
             */
            checkboxMain(row, rowIndex) {
                // if (row.status == "CREATE") {
                return true; // 不禁用
                // } else {
                // return false; // 禁用
                // }
            },
            prints(smCode) {
                // if (this.checkListMain.length == 0) {
                //     this.$message({
                //         message: "请选择打印单！",
                //         type: "warning",
                //     });
                //     return
                // }
                // let list = []
                // this.checkListMain.forEach((item) => {
                //     list.push(item.smCode)
                // })
                // var smCode = list.join(",")
                this.$http
                    .request({
                        url: "/api/stockReturnMat/getStockReturnMatList",
                        method: "GET",
                        params: {
                            smCode: smCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            if (resp.data.list != null) {
                                this.printList = resp.data.list;
                                this.workCenter = resp.data.list[0].workCenter
                                // this.printShow = true;
                                this.getTime()

                            } else {
                                this.$message({
                                    message: "未找到打印记录！",
                                    type: "warning",
                                });
                                return
                            }
                        }
                    })
                    .catch((error) => {});
            },
            printObjList() {
                let code = [];
                for (let i in this.printList) {
                    code.push(this.printList[i].sorCode)
                }
                let stringCode = code.join(",")
                this.$http
                    .request({
                        url: "api/stockPrintDocument/insertStockPrintDocument",
                        method: "POST",
                        showLoading: true,
                        params: {
                            operaCode: stringCode,
                            operaType: '10',
                            fcCode: localStorage.getItem("fcCode") || "",
                            person: localStorage.getItem("user"),
                            personNumber: localStorage.getItem("empNumber"),
                        },
                    })
                    .then((resp) => {})
                    .catch((error) => {});
            },
            /**
             * 获取当前时间
             * 格式YYYY-MM-DD
             */
            getTime() {
                var date = new Date();
                var seperator1 = "/";
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                this.timeDate = year + seperator1 + month + seperator1 + strDate;
            },

            /**
             * 调整箱号（变圈号）
             */
            updateBoxCode(){
                if (this.checkLists.length == 0) {
                    this.$message({
                        message: "请选择要保存的数据！",
                        type: "warning",
                    });
                    return false;
                }
                let updateList = [];
				 const res = this.checkLists.every(e => {
					if (e.boxBarcodeNew=='' || e.boxBarcodeNew==null) {
                        this.$message({
                            message: "圈号不能为空！",
                            type: "warning",
                        });
                        return false;
                    }else {
						if (e.boxBarcode != e.boxBarcodeNew) {
							e.boxBarcode = e.boxBarcodeNew;
                        	updateList.push(e);
                    	}
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }

				if (updateList.length == 0) {
                    this.$message({
                        message: "已选择数据没有修改箱号！",
                        type: "warning",
                    });
                    return false;
                }

                this.$confirm("是否确认调整箱号?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/inventory/updateVirtualInventoryBoxCode",
                                method: "PUT",
                                showLoading: true,
                                params: {
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                },
                                data: updateList,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "SysLocation：圈号调整成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "SysLocation：圈号调整失败";
                                }
                                this.logContent = JSON.stringify(this.checkLists);
                                this.systemLog();
                                //刷新数据
                                this.getVirtualInventory();
                            })
                    })
                    .catch(() => {
                        this.insertInventoryLists = false;
                        this.$message({
                            type: "info",
                            message: "已取消保存",
                        });
                    });
            },

			/**
			 * 调整批次
			 */
			updateBatchNo(){
				if (this.checkLists.length == 0) {
                    this.$message({
                        message: "请选择要保存的数据！",
                        type: "warning",
                    });
                    return false;
                }
                var whCodes = []
                this.checkLists.forEach(e =>{
                    whCodes.push(e.whCode)
                })
                if(new Set(whCodes).size !== 1){
                    this.$message({
                        message: "只能选择通道相同数据！",
                        type: "warning",
                    });
                    return false;
                }
				let updateList = [];
				 const res = this.checkLists.every(e => {
           if (e.batchNoNew == '' || e.batchNoNew == null) {
             this.$message({
               message: "批次号不能为空！",
               type: "warning",
             });
             return false;
           } else if (e.batchNoNew.length > 10) {
             this.$message({
               message: "新批次号长度不能超过10位！",
               type: "warning",
             });
             return false;
           } else if (e.lcCode.indexOf('WIP') != -1) {
             this.$message({
               message: "不能调整WIP库存！",
               type: "warning",
             });
             return false;
           } else {
             if (e.batchNo != e.batchNoNew) {
               e.batchNo = e.batchNoNew;
               updateList.push(e);
             }
             return true;
           }
         })
                if (res == false) {
                    return false;
                }

				if (updateList.length == 0) {
                    this.$message({
                        message: "已选择数据没有修改批次号！",
                        type: "warning",
                    });
                    return false;
                }
                this.updateListAll = updateList;
                this.dialogShowbatch = true;
                this.getTransaction();
			},
            //弹框中-修改批次
            updateVirtualBatch(){
                this.tablecause == '2352';
                if (this.tablecause == '' || this.tablecause == null) {
                    this.$message({
                        message: "原因不能为空！！",
                        type: "warning",
                    });
                    return false;
                }
                this.$confirm("是否确认调整批次?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/inventory/updateVirtualInventoryBatch",
                                method: "PUT",
                                showLoading: true,
                                params: {
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                    reasonCode: this.tablecause || null
                                },
                                data: this.updateListAll,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "SysLocation：批次调整成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "SysLocation：批次调整失败";
                                }
                                this.tablecause = '';
                                this.updateListAll = []
                                this.logContent = JSON.stringify(this.checkLists);
                                this.systemLog();
                                this.dialogShowbatch = false;
                                this.tablecause = "";
                                //刷新数据
                                this.getVirtualInventory();
                            })
                    })
                    .catch(() => {
                        this.insertInventoryLists = false;
                        this.$message({
                            type: "info",
                            message: "已取消保存",
                        });
                    });
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "生产退料",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        showLoading: true,
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
            openTime(){
                this.timer = setInterval(() => {
                    this.getStockPickList();
                }, 600000);
            },

            /**
             * 确认接收
             */
            confirmReceipt() {
                if (this.checkListMains.length == 0) {
                    this.$message({
                        message: "请选择要接收的物料",
                        type: "warning",
                    });
                    return;
                }

                let boxBarcodeList = [];
                for(var index in this.checkListMains) {
                    if (this.checkListMains[index].lcType == null || this.checkListMains[index].lcType != 'PS') {
                        this.$message({
                            message: "该物料不是PS000库存",
                            type: "warning",
                        });
                        return;
                    }
                    if (this.checkListMains[index].receiptResult != '01' && this.checkListMains[index].receiptResult != '20') {
                        this.$message({
                            message: "只能对待接收或者拒绝接收的库存数据进行确认接收！",
                            type: "warning",
                        });
                        return;
                    }
                    boxBarcodeList.push(this.checkListMains[index].boxBarcode);
                }
                if(boxBarcodeList.length==0){
                    return
                }
                this.$confirm("是否确认接收?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/warehouse/confirmReceipt",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                    roleCode: localStorage.getItem("roleCode") || null,
                                },
                                data: boxBarcodeList,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "通道库存：PS物料接收成功"+boxBarcodeList;
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "通道库存：PS物料接收失败";
                                }
                                this.logContent = boxBarcodeList.join(',');
                                this.systemLog();
                                //刷新数据
                                this.getStockPickList();
                            })
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },

            /**
             * 拒绝接收
             */
            rejectReceipt() {
                if (this.checkListMains.length == 0) {
                    this.$message({
                        message: "请选择要拒绝的物料",
                        type: "warning",
                    });
                    return;
                }

                let boxBarcodeList = [];
                for(var index in this.checkListMains) {
                    if (this.checkListMains[index].lcType == null || this.checkListMains[index].lcType != 'PS') {
                        this.$message({
                            message: "该物料不是PS000库存",
                            type: "warning",
                        });
                        return;
                    }
                    if (this.checkListMains[index].receiptResult != '01') {
                        this.$message({
                            message: "只能对待接收的库存数据进行拒绝接收！",
                            type: "warning",
                        });
                        return;
                    }
                    boxBarcodeList.push(this.checkListMains[index].boxBarcode);
                }
                if(boxBarcodeList.length==0){
                    return
                }
                this.$confirm("是否确认拒绝接收?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/warehouse/rejectReceipt",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                },
                                data: boxBarcodeList,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "通道库存：PS物料拒绝成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "通道库存：PS物料拒绝失败";
                                }
                                this.logContent = boxBarcodeList.join(',');
                                this.systemLog();
                                //刷新数据
                                this.getStockPickList();
                            })
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            //获取类型
            getmtTypeList() {
                this.$http.request({
                    url: "/api/dictData/getDictData",
                    method: "GET",
                    showLoading: true,
                    params: {
                        ddCode: "MDTYPE",
                    },
                }).then((resp) => {
                    if (resp.status == 100) {
                        this.mtTypeList = resp.data.list || [];
                    }
                }).catch((error) => { });
            },
            async getMaterialList() {
                try {
                    const res = await this.$http.request({
                        url: "/api/material/getMaterialAll",
                        method: "GET",
                        params: {
                            pageNum: 1,
                            pageSize: 999999,
                        },
                    });
                    if (res.status == 100) {
                        this.materialList = res.data.list;
                    } else {
                        this.materialList = [];
                    }
                } catch (error) {
                    this.materialList = [];
                }
            },
        },
        activated() {
            //添加默认时间
            this.mainSearch.date = [];
            this.mainSearch.date.push(moment().subtract('d', 7).format("YYYY-MM-DD HH:mm"));
            this.mainSearch.date.push(moment().add('d', 1).format("YYYY-MM-DD HH:mm"));
            this.getStockReturnMatPage();
            this.getWarehouse();
            this.getWarnType();
            this.getSysFactory();
            this.judge();
            /* 获取首页的数据 */
            this.getStockPickList();
            this.openTime();

            this.getmtTypeList()
            this.getMaterialList()
        },
        deactivated(){
            clearTimeout(this.timer);
        },
    };
</script>
<style scoped>
    .div div {
        width: 170px;
        height: 50px;
        /* border: 1px solid black; */
        margin-left: 10px;
        margin-top: 10px;
        float: left;
        font-weight: 550;
        font-size: 18px;
    }

    /* .table table {
        margin-top: 3px;
    } */

    table tr th {
        width: 180px;
        border: 1px solid black;
        font-size: 16px;
        text-align: center;
        color: black;
    }

    table tr td{
        width: 180px;
        border: 1px solid black;
        font-size: 14px;
        text-align: center;
        color: black;
    }

    .color {
        background: rgb(194, 192, 192);
        color: black;
    }

    .breaditem {
        background-color: #ecf5ff;
    border-color: #d9ecff;
    display: inline-block;
        border: 1px solid;
        width: auto;
        color: #409EFF;
        font-size: 12px;
        height: 20px;
    padding: 0 5px;
    line-height: 19px;
    cursor: pointer;
    display: inline-block;
    border-radius: 4px;
    margin-left: 10px;
    }
</style>
